// Spanish translations
export const es = {
  // Common
  common: {
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    cancel: "Cancelar",
    confirm: "Confirmar",
    save: "Guardar",
    delete: "Eliminar",
    remove: "Quitar",
    edit: "Editar",
    view: "Ver",
    add: "Agregar",
    search: "Buscar",
    filter: "Filtrar",
    export: "Exportar",
    import: "Importar",
    close: "Cerrar",
    back: "Atrás",
    next: "Siguiente",
    previous: "Anterior",
    yes: "Sí",
    no: "No",
    at: "a las",
    or: "o",
    and: "y",
    email: "Correo electrónico",
    password: "Contraseña",
    name: "Nombre",
    phone: "Teléfono",
    date: "Fecha",
    type: "Tipo",
    status: "Estado",
    page: "Página",
    actions: "Acciones",
    settings: "Configuraciones",
    preferences: "Preferencias",
    language: "Idioma",
    languageCode: "es",
    day: "día",
    days: "días",
    hour: "hora",
    hours: "horas",
    minutes: "minutos",
    week: "semana",
    weeks: "semanas",
    month: "mes",
    months: "meses",
    inactive: "Inactivo",
    sending: "Enviando...",
    copy: "Copiar",
    more: "más",
    tomorrow: "Mañana",
    refresh: "Actualizar",
    menu: "Menú",
    clearFilters: "Restablecer"
  },
  
  // Pagination
  pagination: {
    showing: "Mostrando",
    to: "a",
    of: "de",
    results: "resultados"
  },
  
  // Days of the week
  days: {
    monday: "Lunes",
    tuesday: "Martes",
    wednesday: "Miércoles",
    thursday: "Jueves",
    friday: "Viernes",
    saturday: "Sábado",
    sunday: "Domingo",
    // Short versions
    mon: "Lun",
    tue: "Mar",
    wed: "Mié",
    thu: "Jue",
    fri: "Vie",
    sat: "Sáb",
    sun: "Dom"
  },

  // Navigation - Public Header
  navigation: {
    home: "Inicio",
    about: "Quiénes somos",
    features: "Características",
    pricing: "Precios",
    contact: "Contacto",
    login: "Iniciar sesión",
    signup: "Registrarse",
    dashboard: "Panel de control"
  },

  brand: {
    slogan: "Menos selección. Más talento."
  },

  industries: {
    technology: "Tecnología",
    financial_services: "Servicios financieros",
    healthcare_life_sciences: "Salud y ciencias de la vida",
    education: "Educación",
    retail_ecommerce: "Comercio minorista y e-commerce",
    manufacturing: "Manufactura",
    professional_services_consulting: "Servicios profesionales y consultoría",
    media_marketing_advertising: "Medios, marketing y publicidad",
    telecommunications: "Telecomunicaciones",
    transportation_logistics: "Transporte y logística",
    energy_utilities: "Energía y servicios públicos",
    government_public_sector: "Gobierno y sector público",
    non_profit: "Organización sin fines de lucro",
    real_estate_construction: "Bienes raíces y construcción",
    hospitality_travel: "Hostelería y viajes",
    legal: "Servicios legales",
    human_resources_staffing: "Recursos humanos y staffing",
    other: "Otro"
  },

  // Language Selector
  languages: {
    french: "Francés",
    english: "English",
    spanish: "Español",
    selectLanguage: "Seleccionar idioma"
  },

  // About Page
  about: {
    title: "Acerca de Candio",
    subtitle: "La solución IA para automatizar tu selección de candidatos",
    content: {
      introduction: "Candio es una plataforma SaaS innovadora que revoluciona el proceso de reclutamiento utilizando la inteligencia artificial para analizar y comparar automáticamente los CVs con las ofertas de empleo."
    },
    mission: {
      title: "Nuestra Misión",
      description: "Ayudamos a las empresas de servicios TI y consultoras de RH a ahorrar tiempo y mejorar la calidad de sus reclutamientos gracias a un análisis objetivo y preciso de las candidaturas."
    }
  },

  // Home Page
  home: {
    hero: {
      badge: "Solución #1 para equipos de RRHH TI",
      complianceBadge: "AI Act Proof • Conforme RGPD",
      title: "Deja de clasificar CVs.",
      titleHighlight: "Empieza a preseleccionar a los candidatos correctos.",
      subtitle: "Nosotros hacemos el primer filtro.",
      subtitleHighlight: "Tú te enfocas en contratar a las personas adecuadas.",
      ctaBeta: "Acceso beta",
      ctaPricing: "Ver tarifas",
      guarantees: {
        instant: "Instalación inmediata",
        noCard: "Sin tarjeta de crédito",
        support: "Soporte incluido"
      },
      whiteboard: {
        notes: {
          screening: {
            title: "Shortlist de la mañana",
            body: "Revisar los 5 mejores CVs antes de las 10:00 y enviar shortlist al manager."
          },
          followup: {
            title: "Seguimiento candidatos",
            body: "Llamar a candidatos sin respuesta y confirmar disponibilidad para entrevista."
          },
          interview: {
            title: "Preparación entrevista",
            body: "Alinear criterios de scorecard con el equipo antes de las entrevistas."
          },
          feedback: {
            title: "Bucle de feedback",
            body: "Recoger feedback de entrevista en menos de 2h para mantener el pipeline activo."
          },
          pipeline: {
            title: "Revisión pipeline",
            body: "Detectar etapas bloqueadas y mover perfiles prioritarios al siguiente estado."
          },
          sla: {
            title: "SLA de respuesta",
            body: "Mantener el tiempo de respuesta al candidato por debajo de 24h."
          },
          sourcing: {
            title: "Sourcing diario",
            body: "Identificar nuevos perfiles cualificados para alimentar el pipeline activo."
          },
          sync: {
            title: "Sync equipo RRHH",
            body: "Alinear prioridades de contratación con managers al inicio del día."
          },
          calendar: {
            title: "Bloque agenda",
            body: "Reservar horarios de entrevista para evitar cuellos de botella."
          },
          debrief: {
            title: "Debrief entrevista",
            body: "Centralizar feedback del panel justo después de cada entrevista."
          },
          response: {
            title: "Respuesta candidato",
            body: "Confirmar recepción de candidaturas y mantener respuesta rápida."
          },
          pipelineHealth: {
            title: "Salud del pipeline",
            body: "Detectar etapas bloqueadas y equilibrar carga entre ofertas."
          }
        }
      },
      demo: {
        analyzing: "Análisis IA en progreso...",
        cvCount: "150 CVs",
        completed: "Análisis completado en 3 min 24s",
        timeSaved: "90% de tiempo ahorrado",
        recommended: "Recomendado",
        toConsider: "A considerar",
        aiScore: "Puntuación IA 9,2/10",
        matchRate: "Tasa de coincidencia 92%"
      },
      visual: {
        title: "Motor de matching",
        offerTitle: "Oferta",
        offerRole: "Ingeniero de Datos",
        scoreLabel: "Puntuación global",
        matchLabel: "Oferta vs candidatos",
        breakdown: {
          skills: "Habilidades",
          experience: "Experiencia",
          culture: "Cultura"
        },
        candidatesTitle: "Candidatos top",
        candidates: {
          one: "Amel",
          two: "Karim",
          three: "Lina",
          role1: "Ingeniera de Datos Senior",
          role2: "Ingeniero ML",
          role3: "Analista de Datos"
        }
      }
    },
    painPoints: {
      badge: "Los desafíos diarios de los equipos de RRHH",
      title: "¿Te reconoces en estas situaciones?",
      subtitle: "80% de los profesionales de RRHH pierden tiempo valioso en tareas repetitivas en lugar de concentrarse en lo humano",
      timeWasting: {
        title: "Clasificación manual que consume tiempo",
        description: "Pasas el 80% de tu tiempo clasificando CVs manualmente en lugar de concentrarte en las entrevistas y la relación con los candidatos."
      },
      bias: {
        title: "Riesgo de sesgo inconsciente",
        description: "La selección manual puede introducir sesgos involuntarios que perjudican la diversidad y equidad de tus reclutamientos."
      },
      inconsistency: {
        title: "Proceso no estandarizado",
        description: "Cada reclutador aplica sus propios criterios, creando inconsistencias en la evaluación de candidatos."
      },
      tracking: {
        title: "Dificultad para seguir los KPIs",
        description: "Imposible medir la eficacia de tus procesos de RRHH y optimizar tu rendimiento de reclutamiento."
      },
      preview: {
        fileTitle: "resumen-candidatura.docx",
        documentType: "Documento DOCX",
        context: "Contexto operativo de RRHH",
        noteLabel: "Impacto en terreno",
        lastUpdated: "Actualizado: hoy",
        signature: "Nota diaria RRHH — candio"
      },
      conclusion: "¿Y si pudieras transformar estos desafíos en ventajas competitivas?",
      solution: "Candio automatiza la clasificación para liberar tu tiempo y creatividad"
    },
    process: {
      badge: "Flujo de trabajo automatizado e inteligente",
      title: "6 pasos para revolucionar tu reclutamiento",
      subtitle: "Un proceso simple y fluido que elimina el 90% de las tareas repetitivas",
      before: "Avant",
      beforeTime: "8h de travail",
      now: "Maintenant",
      nowTime: "6 minutes",
      steps: {
        connection: {
          title: "Conexión y Creación de Oferta",
          description: "Conéctate y crea tu oferta de empleo con criterios específicos. Se acabaron las plantillas complejas.",
          time: "3 min",
          oldWay: "❌ Redacción manual, copiar-pegar, múltiples plataformas",
          features: {
            secure: "Interfaz segura",
            fast: "Creación rápida",
            ready: "Listo en 3 min"
          }
        },
        sharing: {
          title: "Publicación y Compartir",
          description: "Publica y comparte tu oferta con un clic. URL única generada automáticamente para todos tus canales.",
          time: "30 seg",
          oldWay: "❌ Publicación manual en cada sitio de empleo",
          features: {
            link: "Enlace único generado",
            multichannel: "Compartir multicanal",
            instant: "Publicación instantánea"
          }
        },
        reception: {
          title: "Recepción Centralizada",
          description: "Todas las candidaturas llegan a un solo lugar. No más correos dispersos o archivos perdidos.",
          time: "Automático",
          oldWay: "❌ Correos dispersos, descargas manuales",
          features: {
            centralized: "Recepción centralizada",
            notifications: "Notificaciones en tiempo real",
            organization: "Organización automática"
          }
        },
        analysis: {
          title: "Análisis IA y Clasificación",
          description: "La IA analiza y clasifica automáticamente todos los CVs por orden de relevancia. Del más recomendado al menos adecuado.",
          time: "2 min para 100 CVs",
          oldWay: "❌ 8h de lectura manual, riesgo de errores",
          features: {
            ai: "IA analiza los CVs",
            score: "Puntuación de compatibilidad",
            ranking: "Clasificación automática"
          }
        },
        generation: {
          title: "Generación de Ficha del Candidato",
          description: "Transforma el CV del candidato recomendado en una ficha estructurada con IA. Toda la información clave extraída.",
          time: "10 seg",
          oldWay: "❌ Entrada manual, reformateo, copiar-pegar",
          features: {
            extraction: "Extracción de datos",
            summary: "Resumen inteligente",
            complete: "Ficha del candidato completa"
          }
        },
        tracking: {
          title: "Seguimiento Kanban",
          description: "Envía la ficha al tablero Kanban y gestiona el proceso de reclutamiento hasta la contratación.",
          time: "1 clic",
          oldWay: "❌ Hojas de Excel, correos de seguimiento manuales",
          features: {
            kanban: "Tablero Kanban visual",
            follow: "Seguimiento del proceso",
            hire: "Hasta la contratación"
          }
        }
      },
      comparison: {
        title: "Resumen: Tu ahorro de tiempo",
        subtitle: "Para un proceso de reclutamiento de 100 candidaturas",
        traditional: "❌ Método Tradicional",
        candio: "✅ Con Candio",
        tasks: {
          creation: "Creación oferta + publicación",
          collection: "Recolección de candidaturas", 
          automated: "Recolección automatizada",
          sorting: "Lectura + clasificación 100 CVs",
          aiSorting: "Análisis IA + clasificación 100 CVs",
          sheets: "Creación fichas candidatos",
          aiSheets: "Generación fichas IA",
          organization: "Organización + seguimiento",
          kanbanSend: "Envío a Kanban"
        },
        total: "TOTAL",
        gain: "Ganancia: 13h 54min",
        percentage: "¡99.3% de tiempo ahorrado!",
        cta: "Prueba este flujo de trabajo ahora"
      },
      traditionalMethod: "Método tradicional:",
      // Process Simplified
      simplified: {
        badge: "Proceso optimizado",
        title: "Simplifica tu reclutamiento en 4 pasos",
        subtitle: "Concéntrate en lo esencial: conocer a los mejores candidatos",
        traditional: "Método tradicional",
        traditionalTime: "14 horas",
        withCandio: "Con Candio",
        candioTime: "6 minutos",
        savings: "Tiempo ahorrado:",
        upload: {
          title: "Crea y publica",
          description: "Crea tu oferta de trabajo y compártela en pocos clics"
        },
        share: {
          title: "Recopila fácilmente",
          description: "Recibe y centraliza todas las aplicaciones automáticamente"
        },
        analyze: {
          title: "Analiza con IA",
          description: "Obtén una clasificación objetiva de candidatos en 2 minutos"
        },
        select: {
          title: "Selecciona y rastrea",
          description: "Gestiona tus candidatos seleccionados en un tablero visual"
        },
        cta: "¿Listo para transformar tu proceso de reclutamiento?",
        ctaButton: "Acceso beta"
      }
    },
    // Appointments Section
    appointments: {
      badge: "Nueva funcionalidad",
      title: "Automatiza tus citas",
      subtitle: "Conecta tus herramientas de videoconferencia favoritas y deja que los candidatos reserven sus horarios",
      features: {
        calendar: {
          title: "Calendario inteligente",
          description: "Define tu disponibilidad y deja que los candidatos elijan"
        },
        candidates: {
          title: "Invitaciones automáticas",
          description: "Envía invitaciones personalizadas con un clic"
        },
        video: {
          title: "Multiplataforma",
          description: "Compatible con tus herramientas de video favoritas"
        }
      },
      howItWorks: {
        title: "¿Cómo funciona?",
        step1: {
          title: "Configura tus herramientas",
          description: "Conecta Teams, Zoom, Meet o Slack"
        },
        step2: {
          title: "Define tus horarios",
          description: "Indica tu disponibilidad"
        },
        step3: {
          title: "Deja que la magia suceda",
          description: "Los candidatos reservan y reciben el enlace automáticamente"
        }
      },
      cta: "Descubre la programación de citas"
    },
    features: {
      title: "Funcionalidades pensadas para RRHH",
      subtitle: "Cada funcionalidad responde a una necesidad concreta de tu día a día",
      aiAnalysis: {
        title: "Análisis IA Objetivo",
        description: "Elimina los sesgos con una evaluación estandarizada basada en criterios empresariales precisos y medibles.",
        benefit: "95% de precisión"
      },
      timeGain: {
        title: "Ahorro de Tiempo Masivo",
        description: "Procesa 500+ CVs por hora vs 20 manualmente. Concéntrate en lo humano, no en la clasificación.",
        benefit: "90% de tiempo ahorrado"
      },
      collaboration: {
        title: "Colaboración RRHH Fluida",
        description: "Kanban interactivo, notas compartidas y flujo de trabajo unificado para un equipo de RRHH alineado y eficaz.",
        benefit: "100% de visibilidad"
      },
      datadriven: {
        title: "Gestión Basada en Datos",
        description: "Paneles de control en tiempo real para medir tus KPIs de RRHH y optimizar tus procesos.",
        benefit: "ROI demostrado"
      }
    },
    roi: {
      badge: "ROI demostrado desde el primer mes",
      title: "Beneficios medibles para tu equipo de RRHH",
      subtitle: "Nuestros clientes constatan un retorno de inversión inmediato con ganancias cuantificables",
      stats: {
        timesSaved: "Tiempo de clasificación ahorrado",
        cvsHour: "CVs analizados/hora",
        precision: "Precisión del análisis",
        availability: "Disponibilidad"
      },
      benefits: {
        measurableRoi: {
          title: "ROI Medible",
          description: "Reducción del 70% del costo por reclutamiento gracias a la automatización de la clasificación.",
          value: "70% de ahorro"
        },
        quality: {
          title: "Calidad Superior",
          description: "Selección más precisa con puntuación objetiva y eliminación de sesgos.",
          value: "40% mejores coincidencias"
        },
        timeToHire: {
          title: "Time-to-Hire Optimizado",
          description: "Reducción drástica del tiempo entre publicación y primera selección.",
          value: "60% más rápido"
        },
        satisfaction: {
          title: "Satisfacción del Equipo",
          description: "Tu RRHH se concentra en lo humano y la estrategia, no en la clasificación.",
          value: "85% de satisfacción"
        }
      },
      calculator: {
        title: "Calcula tu ROI en 30 segundos",
        subtitle: "¿Cuánto tiempo pasa tu equipo clasificando CVs cada semana? Descubre tus ahorros potenciales con Candio.",
        ctaCalculate: "Calcular mi ROI",
        ctaDemo: "Solicitar una demo",
        roiValue: "3.2x",
        roiDescription: "ROI promedio constatado desde el primer mes"
      }
    },
    testimonials: {
      badge: "Testimonios de clientes verificados",
      title: "Han transformado su reclutamiento",
      subtitle: "Descubre cómo los equipos de RRHH utilizan Candio para revolucionar sus procesos",
      testimonial1: {
        name: "Marie Dubois",
        role: "Directrice RH",
        company: "TechCorp Solutions",
        content: "Candio ha revolucionado nuestro proceso de reclutamiento. Ahora procesamos 10 veces más candidaturas con el mismo equipo de RRHH. El ROI es evidente desde el primer mes.",
        result: "300% más eficiencia"
      },
      testimonial2: {
        name: "Pierre Martin", 
        role: "Consultant Senior",
        company: "HR Excellence",
        content: "El análisis de IA es impresionantemente preciso. Nuestros clientes están encantados con la calidad de las preselecciones. Sin sesgos, sin errores.",
        result: "95% de precisión"
      },
      testimonial3: {
        name: "Sophie Chen",
        role: "Responsable Recrutement",
        company: "DevTech Partners",
        content: "Antes de Candio, pasábamos el 80% de nuestro tiempo clasificando. Ahora, nos concentramos en lo humano y la estrategia de RRHH.",
        result: "80% de tiempo liberado"
      },
      stats: {
        rating: "Calificación promedio",
        customers: "Clientes satisfechos",
        retention: "Tasa de retención"
      }
    },
    community: {
      badge: "Comunidad de lanzamiento",
      title: "Apoya a Candio durante nuestra fase de lanzamiento",
      subtitle: "Candio está en fase de pruebas. Únete a la lista para seguir el lanzamiento oficial y apoyar una solución 100% quebequense.",
      points: {
        testing: "Acceso prioritario a anuncios de lanzamiento y hitos del producto.",
        support: "Apoya directamente el producto uniéndote a nuestra comunidad.",
        quebec: "Una solución tecnológica de RRHH orgullosamente desarrollada en Quebec."
      },
      form: {
        label: "Unirme a la lista de lanzamiento",
        placeholder: "nombre@empresa.com",
        cta: "Unirme a la comunidad",
        loading: "Registrando...",
        success: "¡Gracias! Tu correo fue añadido a la lista de lanzamiento.",
        error: "No se pudo añadir tu correo por ahora. Inténtalo de nuevo.",
        invalidEmail: "Por favor introduce un correo válido.",
        disclaimer: "Solo enviamos actualizaciones importantes del lanzamiento. Sin spam."
      }
    },
    cta: {
      badge: "Programa beta abierto",
      title: "¿Listo para liberar el 90% de tu tiempo",
      titleHighlight: "de clasificación de CVs?",
      subtitle: "Únete a los equipos de RRHH que ya han transformado su reclutamiento.",
      subtitleHighlight: "Instalación en 5 minutos • Resultados desde la primera semana",
      button: "Acceso beta",
      guarantees: {
        trial: "7 días gratis, sin compromiso",
        instant: "Configuración inmediata", 
        support: "Soporte dedicado incluido"
      }
    },
    footer: {
      description: "Menos selección. Más talento.",
      product: {
        title: "Producto",
        features: "Funcionalidades",
        pricing: "Registro",
        api: "API"
      },
      company: {
        title: "Empresa",
        about: "Acerca de",
        contact: "Contacto",
        careers: "Carreras"
      },
      support: {
        title: "Soporte",
        documentation: "Documentación",
        guides: "Guías",
        security: "Seguridad y privacidad"
      },
      copyright: "&copy; 2025 Candio. Todos los derechos reservados."
    }
  },

  // Features Page
  features: {
    title: "Funcionalidades Poderosas para el Reclutamiento Moderno",
    subtitle: "Todo lo que necesitas para optimizar tu proceso de contratación",
    
    // Hero section
    heroTitle: "Funcionalidades",
    heroTitleHighlight: "Innovadoras",
    heroSubtitle: "Descubre un conjunto completo de herramientas de reclutamiento diseñado para simplificar y optimizar tu proceso de selección de talentos.",
    
    // Main features sections
    needsTitle: "Todo lo que necesitas",
    needsSubtitle: "Una plataforma completa que cubre todos los aspectos del reclutamiento moderno",
    whyChooseTitle: "¿Por qué elegir nuestra solución?",
    whyChooseSubtitle: "Ventajas concretas que transforman tu forma de reclutar",
    processTitle: "Un proceso simplificado",
    processSubtitle: "Desde la publicación de ofertas hasta la contratación, un flujo de trabajo optimizado",
    ctaTitle: "¿Listo para transformar tu reclutamiento?",
    ctaSubtitle: "Únete a las empresas que ya han revolucionado su proceso de reclutamiento",
    ctaStartNow: "Acceso beta",
    ctaContact: "Contáctanos",
    
    // Database feature
    database: {
      title: "Base de CVs Centralizada",
      description: "Organiza y gestiona tu base de datos de candidatos en un espacio unificado con herramientas de búsqueda avanzadas.",
      benefits: {
        import: "Importación múltiple",
        organization: "Organización inteligente",
        search: "Búsqueda rápida"
      }
    },
    
    // Offer management
    offerManagement: {
      title: "Gestión de Ofertas",
      description: "Crea, publica y gestiona tus ofertas de empleo con herramientas modernas de difusión y seguimiento.",
      benefits: {
        creation: "Creación simplificada",
        publication: "Publicación multicanal",
        tracking: "Seguimiento del rendimiento"
      }
    },
    
    // Application centralization
    applicationCentralization: {
      title: "Centralización de Candidaturas",
      description: "Recopila automáticamente todas las candidaturas y gestiónalas desde una interfaz unificada.",
      benefits: {
        collection: "Recolección automática",
        sorting: "Clasificación inteligente",
        notifications: "Notificaciones en tiempo real"
      }
    },
    
    // Recruitment tracking
    recruitmentTracking: {
      title: "Seguimiento de Reclutamiento",
      description: "Visualiza y gestiona el proceso de reclutamiento con herramientas colaborativas intuitivas.",
      benefits: {
        visual: "Interfaz visual",
        collaboration: "Colaboración en equipo",
        tracking: "Seguimiento de etapas"
      }
    },
    
    // Notes management
    notesManagement: {
      title: "Gestión de Notas",
      description: "Comparte notas y comentarios con tu equipo para una colaboración óptima.",
      benefits: {
        shared: "Notas compartidas",
        realtime: "Colaboración en tiempo real",
        history: "Historial completo"
      }
    },
    
    // AI Matching (existing)
    aiMatching: {
      title: "Comparador IA",
      description: "Analiza y compara las candidaturas con algoritmos avanzados para optimizar tus decisiones.",
      benefits: {
        automatic: "Análisis automático",
        intelligent: "Comparación inteligente",
        decision: "Ayuda en la toma de decisiones"
      }
    },
    
    // Appointment booking
    appointmentBooking: {
      title: "Reserva de Citas",
      description: "Simplifica la programación de entrevistas con un sistema de reserva en línea tipo Calendly, integrado para equipos de RRHH.",
      benefits: {
        calendar: "Calendario inteligente",
        automation: "Reserva automática",
        videoIntegration: "Video integrado"
      }
    },
    
    // Benefits section
    benefits: {
      timeGain: {
        title: "Ahorro de Tiempo",
        description: "Automatiza las tareas repetitivas y concéntrate en lo humano"
      },
      precision: {
        title: "Mayor Precisión",
        description: "Encuentra los mejores candidatos gracias a la inteligencia artificial"
      },
      security: {
        title: "Seguridad Garantizada",
        description: "Tus datos están protegidos con los más altos estándares de seguridad"
      },
      accessibility: {
        title: "Accesibilidad",
        description: "Accede a tu plataforma desde cualquier lugar, en cualquier momento"
      }
    },
    
    // Stats section
    stats: {
      timeReduction: "Reducción del tiempo de clasificación",
      precisionImprovement: "Mejora de la precisión",
      processAcceleration: "Aceleración del proceso",
      userSatisfaction: "Satisfacción del usuario"
    },
    outcomes: {
      title: "Resultados medibles",
      subtitle: "Pruebas concretas del uso diario"
    },
    
    // Process steps
    processSteps: {
      publication: {
        title: "Publicación",
        description: "Crea y difunde tus ofertas"
      },
      collection: {
        title: "Recolección",
        description: "Recibe las candidaturas"
      },
      analysis: {
        title: "Análisis",
        description: "Evalúa con IA"
      },
      selection: {
        title: "Selección",
        description: "Elige a los mejores"
      }
    },
    
    // Legacy features for backward compatibility
    batchAnalysis: {
      title: "Análisis por Lotes",
      description: "Carga y analiza varios CVs a la vez. Obtén informes completos comparando todos los candidatos simultáneamente."
    },
    kanbanBoard: {
      title: "Gestión con Tablero Kanban",
      description: "Organiza a los candidatos en tu proceso de reclutamiento con nuestra interfaz intuitiva de arrastrar y soltar."
    },
    teamCollaboration: {
      title: "Colaboración en Equipo",
      description: "Comparte perfiles de candidatos, agrega notas y colabora con tus colegas durante todo el proceso de contratación."
    },
    customBranding: {
      title: "Marca Personalizada",
      description: "Personaliza la plataforma con tu logo y colores corporativos para una experiencia profesional."
    }
  },

  // Pricing Page
  pricing: {
    title: "Elige Tu Plan",
    subtitle: "Tarifas flexibles que evolucionan con tu empresa",
    monthly: "Mensuel",
    yearly: "Annuel",
    save: "Ahorra 20%",
    popular: "Más Popular",
    free: "Gratis",
    planNames: {
      demo: "Demo Gratis",
      essential: "Esencial RH",
      enterprise: "Empresa"
    },
    demo: {
      name: "Demo",
      price: "Gratis",
      duration: "",
      description: "Perfecto para probar nuestra plataforma",
      features: [
        "10 análisis IA por mes",
        "1 usuario RRHH",
        "5 ofertas de empleo",
        "50 cargas de CV",
        "Soporte básico",
        "Funcionalidades estándar"
      ],
      cta: "Comenzar Demo Gratis"
    },
    essential: {
      name: "Esencial",
      price: "49€",
      duration: "/mes",
      description: "Ideal para equipos pequeños",
      features: [
        "100 análisis IA por mes",
        "2 usuarios RRHH",
        "10 ofertas de empleo",
        "500 cargas de CV",
        "Soporte por email",
        "Colaboración en equipo",
        "Informes básicos"
      ],
      cta: "Elegir Esencial"
    },
    enterprise: {
      name: "Empresa",
      price: "149€",
      duration: "/mes",
      description: "Para empresas en crecimiento",
      features: [
        "500 análisis IA por mes",
        "10 usuarios RRHH",
        "50 ofertas de empleo",
        "2000 cargas de CV",
        "Soporte prioritario",
        "Marca personalizada",
        "Informes avanzados",
        "Almacenamiento MinIO personalizado"
      ],
      cta: "Elegir Empresa"
    },
    customDescription: "Plan personalizado para sus necesidades",
    features: {
      title: "Todos los planes incluyen:",
      list: [
        "Análisis de CV por IA",
        "Gestión con tablero Kanban",
        "Colaboración en tiempo real",
        "Cifrado seguro de datos",
        "Interfaz responsive móvil",
        "Actualizaciones regulares"
      ],
      aiAnalysis: "Análisis de CV por IA",
      kanbanManagement: "Gestión de tablero Kanban",
      realtimeCollaboration: "Colaboración en tiempo real",
      secureEncryption: "Cifrado seguro de datos",
      responsiveInterface: "Interfaz responsive móvil",
      regularUpdates: "Actualizaciones regulares",
      batchProcessing: "Procesamiento por lotes",
      exportFormats: "Exportar PDF/Excel",
      searchFilters: "Filtros de búsqueda avanzados",
      emailNotifications: "Notificaciones por correo",
      dashboardWidgets: "Widgets del panel",
      multiLanguage: "Soporte multiidioma",
      hrUsers: "Usuarios de RH incluidos",
      hrUsersDesc: "Número de usuarios de RH que pueden acceder al sistema",
      jobOffers: "Ofertas de empleo activas",
      jobOffersDesc: "Número máximo de ofertas de empleo simultáneas",
      cvUploads: "Cargas de CV (repositorio interno)",
      cvUploadsDesc: "Almacenamiento de CV para su base de datos interna",
      aiClassifier: "Clasificador inteligente (IA)",
      aiClassifierDesc: "Análisis de IA para clasificar y evaluar CVs",
      aiSummary: "Resumen automático de CV (IA)",
      aiSummaryDesc: "Generación automática de resúmenes de CV",
      appointments: "Reserva de citas",
      appointmentsDesc: "Sistema de reserva en línea para candidatos",
      new: "Nuevo",
      customStorage: "Almacenamiento MinIO personalizado",
      customStorageDesc: "Use su propio servicio de almacenamiento MinIO para documentos",
      videoAutomation: "Automatización URL reunión",
      videoAutomationDesc: "Generación automática de enlaces de videoconferencia con servicios de terceros",
      enterprise: "Enterprise"
    },
    additionalFeatures: {
      title: "Características adicionales",
      demo: [
        "Acceso limitado a funciones",
        "Datos de demostración",
        "Soporte comunitario"
      ],
      essential: [
        "Todas las funciones básicas",
        "Integraciones básicas",
        "Formación en línea"
      ],
      enterprise: [
        "Todas las funciones Premium",
        "Integraciones personalizadas",
        "Formación en sitio",
        "Gerente de cuenta dedicado"
      ],
      tracking: "Seguimiento de ofertas y monitoreo",
      applications: "Gestión de candidaturas",
      kanban: "Tablero Kanban – seguimiento de reclutamiento",
      notes: "Notas colaborativas y compartidas",
      emailSupport: "Soporte por correo",
      prioritySupport: "Soporte prioritario e intervención"
    },
    currentPlan: "Plan actual",
    perMonth: "mes",
    startFree: "Comenzar gratis",
    choosePlan: "Elegir este plan",
    redirecting: "Redirigiendo...",
    loginRequired: "Inicia sesión para suscribirte",
    demoIncluded: "El paquete Demo ya está incluido en tu cuenta",
    packageNotFound: "Paquete no encontrado",
    missingPaymentConfig: "Configuración de pago faltante para este paquete",
    invalidPriceConfig: "Configuración de precio inválida",
    subscriptionActivated: "¡Suscripción activada con éxito!",
    subscriptionError: "Error al suscribirse",
    premium: "Premium",
    current: "Actual",
    needHelp: "¿Necesita ayuda para elegir el plan correcto?",
    contactUs: "Contáctenos",
    error: {
      load: "Error al cargar los paquetes"
    },
    comparison: {
      title: "Compara nuestros planes",
      features: "Características",
      feature: "Característica",
      aiAnalyses: "Análisis de IA por mes",
      hrUsers: "Usuarios de RR.HH.",
      jobOffers: "Ofertas de trabajo",
      cvUploads: "Cargas de CV",
      support: "Soporte",
      teamCollaboration: "Colaboración en equipo",
      reports: "Informes",
      customBranding: "Marca personalizada",
      minioStorage: "Almacenamiento MinIO personalizado",
      advancedAnalytics: "Análisis avanzados",
      apiAccess: "Acceso API",
      sla: "SLA garantizado",
      included: "Incluido",
      notIncluded: "-",
      basic: "Básico",
      email: "Por correo",
      priority: "Prioritario",
      advanced: "Avanzados",
      custom: "Personalizado"
    },
    faq: {
      title: "Preguntas frecuentes",
      subtitle: "Todo lo que necesitas saber sobre nuestros planes",
      changePlan: {
        question: "¿Puedo cambiar de plan en cualquier momento?",
        answer: "Sí, puedes cambiar a un plan superior o inferior en cualquier momento. Los cambios tienen efecto inmediato."
      },
      limits: {
        question: "¿Qué pasa si excedo mis límites?",
        answer: "Tu acceso será suspendido temporalmente hasta la renovación de tu suscripción o la actualización a un plan superior."
      },
      hrUsers: {
        question: "¿Los usuarios de RR.HH. tienen acceso a las mismas funciones?",
        answer: "Sí, los usuarios de RR.HH. creados por un administrador heredan automáticamente los privilegios de suscripción del administrador."
      },
      cancel: {
        question: "¿Puedo cancelar mi suscripción?",
        answer: "Sí, puedes cancelar tu suscripción en cualquier momento. Mantendrás el acceso hasta el final de tu período de facturación."
      },
      appointments: {
        question: "¿Cómo funcionan las citas?",
        answer: "Las citas te permiten programar entrevistas directamente con los candidatos seleccionados. Puedes gestionar tu calendario, enviar invitaciones y seguir las confirmaciones desde tu panel de control."
      },
      trial: {
        question: "¿Hay un período de prueba gratuito?",
        answer: "Sí, nuestro plan Demo ofrece acceso gratuito con 10 análisis de IA por mes para probar todas las funciones de la plataforma sin compromiso."
      }
    }
  },

  // Contact Page
contact: {
  title: "Contáctanos",
  subtitle: "¿Preguntas? Estaremos encantados de saber de ti",
  hero: {
    title: "Contacta a Nuestro Equipo",
    subtitle: "¿Tienes una pregunta? ¿Necesitas ayuda? Nuestro equipo de expertos está aquí para acompañarte en tu transformación digital de RRHH."
  },
    form: {
      title: "Envíanos un mensaje",
      subtitle: "Completa el formulario a continuación y te responderemos rápidamente.",
      name: "Nombre completo",
      namePlaceholder: "Tu nombre completo",
      email: "Dirección de email",
      emailPlaceholder: "tu.email@empresa.com",
      company: "Nombre de la empresa",
      subject: "Asunto de tu solicitud",
      message: "Tu mensaje",
      messagePlaceholder: "Describe tu solicitud en detalle...",
      characters: "caracteres",
      send: "Enviar mensaje",
      sending: "Enviando...",
      success: "Mensaje enviado con éxito. Te responderemos en 24 horas.",
      errors: {
        nameRequired: "El nombre es requerido",
        emailRequired: "El email es requerido",
        emailInvalid: "Email inválido",
        messageRequired: "El mensaje es requerido",
        messageTooShort: "El mensaje debe contener al menos 10 caracteres",
        formValidation: "Por favor corrige los errores en el formulario",
        sendError: "Error al enviar el mensaje",
        connectionError: "Error de conexión. Por favor inténtalo de nuevo o contáctanos directamente en hello@candio.ai"
      }
    },
    success: {
      title: "¡Mensaje enviado!",
      message: "¡Gracias por tu mensaje! Te responderemos pronto."
    },
    subjects: {
      support: {
        label: "Soporte Técnico",
        description: "Ayuda, preguntas técnicas, problemas"
      },
      sales: {
        label: "Demo y onboarding", 
        description: "Demo, onboarding, preguntas generales"
      },
      general: {
        label: "Pregunta General",
        description: "Información, asociación, otros"
      }
    },
    info: {
      title: "Informations de Contact",
      email: {
        title: "Correo electrónico",
        description: "Respondemos en 24 horas"
      },
      hours: {
        title: "Horario de Soporte",
        value: "Lun-Vie 9h-18h",
        description: "Hora de Francia (GMT+1)"
      },
      multilingual: {
        title: "Soporte Multilingüe",
        value: "FR / EN / ES",
        description: "Francés, Inglés y Español"
      },
      responseTime: "Generalmente respondemos dentro de las 24 horas hábiles."
    },
    why: {
      title: "¿Por qué contactarnos?",
      demo: {
        title: "Demo personalizada",
        description: "Descubre Candio adaptado a tus necesidades"
      },
      support: {
        title: "Soporte experto",
        description: "Ayuda técnica y acompañamiento"
      },
      pricing: {
        title: "Onboarding a medida",
        description: "Onboarding y acompañamiento adaptados a tu organización"
      },
      training: {
        title: "Formación de equipo",
        description: "Onboarding y formación de usuarios"
      }
    },
    response: {
      title: "Respuesta Garantizada",
      subtitle: "Nos comprometemos a responder todos los mensajes",
      sales: "Preguntas de ventas",
      support: "Soporte técnico"
    },
    error: "Se produjo un error al enviar tu mensaje. Por favor inténtalo de nuevo.",
    modal: {
      title: "Contáctanos",
      subtitle: "Estamos aquí para ayudarte"
    },
    validation: {
      messageRequired: "El mensaje es requerido"
    },
    errors: {
      sendFailed: "Error al enviar el mensaje"
    }
  },

  // Authentication
  auth: {
    common: {
      secure: "Seguro"
    },
    password: {
      show: "Mostrar contraseña",
      hide: "Ocultar contraseña"
    },
    // Validation errors
    validation: {
      invalidEmail: "Dirección de correo electrónico inválida",
      passwordMinLength: "La contraseña debe tener al menos 8 caracteres",
      nameLength: "El nombre debe tener entre 2 y 100 caracteres",
      passwordRequired: "Se requiere contraseña",
      emailRequired: "La dirección de correo electrónico es requerida",
      emailInvalid: "Por favor ingrese una dirección de correo válida",
      confirmPasswordRequired: "Por favor confirme su contraseña",
      passwordsDoNotMatch: "Las contraseñas no coinciden",
      allFieldsRequired: "Todos los campos son requeridos"
    },
    // Resend verification
    resend: {
      userNotFoundOrVerified: "Usuario no encontrado o ya verificado",
      success: "Correo electrónico de verificación enviado exitosamente",
      failed: "Error al enviar el correo electrónico de verificación"
    },
    // General auth errors
    error: {
      tooManyAttempts: "Demasiados intentos de autenticación. Por favor, intente de nuevo en {{minutes}} minutos.",
      internal: "Error interno del servidor",
      userNotFound: "Usuario no encontrado"
    },
    // Email verification
    verify: {
      tokenRequired: "Se requiere token de verificación",
      invalidToken: "Token de verificación inválido o expirado",
      success: "Correo electrónico verificado exitosamente. Ahora puede iniciar sesión.",
      alreadyVerified: "Correo electrónico ya verificado. Puede iniciar sesión."
    },
    // Messages
    messages: {
      connectionError: "Error de conexión. Por favor, inténtalo de nuevo.",
      resendError: "Error al enviar el correo electrónico",
      verificationRequired: "Se requiere verificación de correo electrónico",
      signupSuccess: "¡Cuenta creada con éxito! Por favor, revisa tu bandeja de entrada para verificar tu dirección de correo electrónico.",
      signupError: "Error al crear la cuenta",
      backToHome: "Volver al inicio",
      newToCandio: "¿Nuevo en Candio?",
      createAccountForTrial: "Crea tu cuenta y obtén 2 días de prueba gratis",
      startFreeTrial: "Comenzar prueba gratis"
    },
    login: {
      title: "Accede a tu espacio",
      subtitle: "Inicia sesión para continuar.",
      helperText: "El idioma y la zona horaria del espacio de trabajo se aplican en la autenticación.",
      email: "Dirección de email",
      password: "Contraseña",
      or: "o",
      forgotPassword: "¿Contraseña olvidada?",
      loginButton: "Iniciar sesión",
      noAccount: "¿No tienes una cuenta?",
      signUp: "Regístrate aquí",
      // Login errors
      userNotFound: "No se encontró ninguna cuenta con esta dirección de correo electrónico.",
      incorrectPassword: "Contraseña incorrecta. Por favor, verifique su contraseña.",
      notVerified: "Cuenta no verificada",
      notVerifiedMessage: "Por favor, verifique su correo electrónico antes de iniciar sesión. Revise su bandeja de entrada.",
      licenseExpired: "Licencia expirada",
      errors: {
        invalidCredentials: "Email o contraseña inválidos",
        emailRequired: "El email es requerido",
        emailInvalid: "Por favor ingresa un email válido",
        passwordRequired: "La contraseña es requerida",
        userNotFound: "No se encontró ninguna cuenta con esta dirección de correo electrónico.",
        invalidPassword: "Contraseña incorrecta. Por favor, verifique su contraseña.",
        accountNotVerified: "Cuenta no verificada",
        verifyEmailFirst: "Por favor, verifique su correo electrónico antes de iniciar sesión. Revise su bandeja de entrada.",
        licenseExpired: "Licencia expirada"
      }
    },
    signup: {
      title: "Crea tu espacio Candio",
      subtitle: "Regístrate en pocos pasos.",
      fullName: "Nombre completo (opcional)",
      email: "Dirección de email",
      password: "Contraseña",
      confirmPassword: "Confirmar contraseña",
      passwordHint: "Mínimo 8 caracteres",
      company: "Nombre de la empresa",
      companyPlaceholder: "Nombre de tu empresa",
      industry: "Sector de actividad",
      industryPlaceholder: "Tecnología, Salud, Finanzas...",
      timezone: "Zona horaria",
      selectTimezone: "Selecciona tu zona horaria",
      selectIndustry: "Selecciona tu sector",
      signupButton: "Crear mi cuenta",
      hasAccount: "¿Ya tienes una cuenta?",
      signIn: "Iniciar sesión",
      helperText: "El perfil de empresa y la zona horaria se usan para configurar los valores por defecto del espacio de trabajo.",
      terms: "Al crear una cuenta, aceptas nuestros Términos de uso y Política de privacidad",
      freeTrialTitle: "Prueba gratuita incluida",
      freeTrialDescription: "2 días de acceso completo • 10 análisis • Todas las funcionalidades",
      errors: {
        nameRequired: "El nombre completo es requerido",
        nameTooShort: "El nombre debe contener al menos 2 caracteres",
        emailRequired: "El email es requerido",
        emailInvalid: "Por favor ingresa un email válido",
        passwordRequired: "La contraseña es requerida",
        passwordTooShort: "La contraseña debe contener al menos 8 caracteres",
        confirmPasswordRequired: "Por favor confirma tu contraseña",
        passwordsNoMatch: "Las contraseñas no coinciden",
        companyRequired: "El nombre de la empresa es requerido",
        industryRequired: "El sector de actividad es requerido",
        timezoneRequired: "La zona horaria es requerida",
        emailExists: "Esta dirección de correo electrónico ya está en uso. Intente iniciar sesión o use una dirección diferente.",
        signupFailed: "Error al crear la cuenta",
        internalError: "Error interno del servidor"
      },
      success: {
        accountCreated: "¡Cuenta creada exitosamente! Por favor, revise su correo electrónico.",
        accountCreatedDev: "¡Cuenta creada exitosamente! (Verificación automática en desarrollo)",
        accountCreatedEmailFailed: "¡Cuenta creada exitosamente! La verificación por correo falló pero la cuenta está activada."
      },
      passwordChecks: {
        title: "Requisitos de contraseña",
        length: "Al menos 8 caracteres",
        uppercase: "Una letra mayúscula",
        lowercase: "Una letra minúscula",
        number: "Un número"
      },
      or: "O"
    },
    verification: {
      title: "Verificación de Email",
      subtitle: "Hemos enviado un enlace de verificación a tu dirección de email",
      checkEmail: "Por favor verifica tu email y haz clic en el enlace de verificación para completar tu registro.",
      checkEmailPrompt: "Tu cuenta aún no está verificada. Verifica tu email o reenvía un nuevo enlace.",
      resend: "Reenviar email de verificación",
      unverifiedAccount: "Cuenta no verificada",
      backToLogin: "Volver al inicio de sesión",
      states: {
        verifying: "Verificando...",
        pleasewait: "Por favor espera mientras verificamos tu email.",
        success: "¡Email verificado con éxito!",
        accountActivated: "Tu cuenta ha sido activada. Ahora puedes iniciar sesión.",
        error: "Error de verificación",
        invalidLink: "El enlace de verificación es inválido o ha expirado.",
        alreadyVerified: "Correo electrónico ya verificado. Puede iniciar sesión."
      },
      actions: {
        createNewAccount: "Crear una nueva cuenta",
        tryLogin: "Intentar iniciar sesión"
      },
      errors: {
        missingToken: "Token de verificación faltante",
        verificationFailed: "La verificación falló. Por favor, inténtalo de nuevo.",
        tokenRequired: "Se requiere token de verificación",
        invalidToken: "Token de verificación inválido o expirado",
        userNotFound: "Usuario no encontrado o ya verificado",
        resendFailed: "Error al enviar el correo electrónico de verificación"
      },
      messages: {
        success: "¡Correo electrónico verificado con éxito!"
      },
      help: {
        needHelp: "¿Necesitas ayuda?",
        contactUs: "Contáctanos"
      },
      success: {
        emailSent: "Correo electrónico de verificación enviado exitosamente"
      }
    },
    // Forgot password
    forgotPassword: {
      title: "¿Olvidaste tu contraseña?",
      subtitle: "Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña",
      emailLabel: "Dirección de correo electrónico",
      emailPlaceholder: "tu@email.com",
      sendResetLink: "Enviar enlace de restablecimiento",
      backToLogin: "Volver al inicio de sesión",
      emailSentTitle: "¡Correo enviado!",
      emailSentDescription: "Enviamos un enlace para restablecer la contraseña a {{email}}",
      checkSpam: "Si no ves el correo electrónico, revisa tu carpeta de spam.",
      checkEmailMessage: "Si existe una cuenta con esta dirección de correo electrónico, recibirás un enlace para restablecer la contraseña.",
      emailSentSuccess: "Correo electrónico enviado exitosamente"
    },
    // Reset password
    resetPassword: {
      title: "Restablecer contraseña",
      subtitle: "Elige una nueva contraseña segura",
      newPassword: "Nueva contraseña",
      confirmPassword: "Confirmar contraseña",
      resetButton: "Restablecer contraseña",
      backToLogin: "Volver al inicio de sesión",
      invalidToken: "Enlace de restablecimiento inválido o expirado",
      successTitle: "¡Contraseña restablecida!",
      successDescription: "Tu contraseña ha sido restablecida exitosamente",
      successMessage: "Tu contraseña ha sido restablecida exitosamente. Ahora puedes iniciar sesión.",
      redirectingToLogin: "Redirigiendo a la página de inicio de sesión..."
    },
    // Auth Banner
    banner: {
      login: {
        title: "Bienvenido a Candio",
        subtitle: "La solución IA para optimizar tus reclutamientos"
      },
      signup: {
        title: "Únete a Candio",
        subtitle: "Comienza tu prueba gratuita hoy"
      },
      features: {
        matching: {
          title: "Matching IA preciso",
          description: "Encuentra los mejores candidatos en segundos"
        },
        analytics: {
          title: "Analíticas avanzadas",
          description: "Sigue el rendimiento de tus reclutamientos en tiempo real"
        },
        collaboration: {
          title: "Colaboración en equipo",
          description: "Trabaja junto en tus procesos de reclutamiento"
        }
      },
      stats: {
        companies: "Empresas",
        cvs: "CVs analizados",
        satisfaction: "Satisfacción"
      },
      trust: {
        secure: "Datos seguros",
        compliant: "RGPD Compliant"
      }
    }
  },

  // Dashboard
  dashboard: {
    welcome: "Hola",
    overview: "Visión general",
    quickActions: "Acciones rápidas",
    recentActivity: "Actividad reciente",
    statistics: "Estadísticas",
    noRecentActivity: "Sin actividad reciente",
    subtitle: {
      admin: "Aquí tienes un resumen de la actividad de tu equipo",
      hr: "Aquí tienes un resumen de la actividad compartida de tu equipo"
    },
    plan: {
      current: "Plan",
      expired: "Expirado",
      expiredTitle: "Plan expirado",
      expiredMessage: "Tu plan {{planName}} ha expirado. Renueva tu suscripción para continuar usando Candio."
    },
    planInfo: {
      title: "Información del plan",
      planType: "Plan",
      demo: "Demo",
      active: "Actif",
      inactive: "Inactif",
      expiresOn: "Expira el",
      analyses: "Análisis",
      perMonth: "mes",
      offers: "Ofertas",
      cvs: "CVs",
      hrUsers: "Usuarios RRHH",
      activePlan: "Plan activo",
      users: "Usuarios",
      lastSync: "Última sincronización"
    },
    workspace: {
      shared: "Espacio de trabajo compartido"
    },
    roles: {
      admin: "Admin",
      hr: "RH"
    },
    actions: {
      sync: "Sincronizar",
      refresh: "Actualizar"
    },
    errors: {
      syncFailed: "Error al sincronizar",
      general: "Error",
      activitiesLoadFailed: "Error al cargar la actividad",
      notesLoadFailed: "Error al cargar las notas",
      quickActionsLoadFailed: "Error al cargar las acciones rápidas",
      calendarLoadFailed: "Error al cargar el calendario",
      preferencesLoadFailed: "Error al cargar las preferencias del panel",
      preferencesSaveFailed: "Error al guardar las preferencias del panel"
    },
    pagination: {
      showing: "Mostrando",
      to: "a",
      of: "de",
      entries: "entradas",
      previous: "Anterior",
      next: "Siguiente"
    },
    
    // Navigation
    nav: {
      dashboard: "Panel de control",
      offers: "Ofertas de empleo",
      cvs: "Banco de CVs",
      analyzer: "Analizador IA",
      results: "Resultados",
      kanban: "Kanban",
      candidates: "Candidatos",
      appointments: "Citas",
      settings: "Configuraciones",
      hrManagement: "Gestión RRHH",
      pricing: "Suscripción",
      notes: "Notas",
      applications: "Candidaturas",
      env: "Variables",
      community: "Comunidad"
    },

    // Widgets
    widgets: {
      offers: "Ofertas de empleo",
      cvs: "CVs cargados",
      hrUsers: "Usuarios RRHH",
      analyses: "Análisis IA",
      aiResume: "Resumen IA CV",
      remaining: "{{count}} restante{{plural}}",
      limitReached: "Límite alcanzado",
      recentNotes: "Notas recientes",
      addQuickNote: "Agregar una nota rápida",
      noNotes: "Sin notas por el momento",
      createFirstNote: "Crea tu primera nota arriba",
      shared: "Compartido",
      sharedBy: "por {{name}}",
      viewAllNotes: "Ver todas las notas",
      sharedCalendar: {
        title: "Calendario compartido",
        noAppointments: "Sin citas",
        viewAll: "Ver todas las citas"
      },
      quickActions: "Acciones rápidas",
      basedOnUsage: "Basado en tu uso",
      noActionsAvailable: "Sin acciones disponibles",
      navigationError: "Error al navegar",
      frequency: {
        once: "1 vez",
        times: "{{count}} veces",
        many: "10+ veces"
      },
      offersData: {
        title: "Ofertas de empleo",
        open: "Abiertas",
        closed: "Cerradas",
        cancelled: "Canceladas"
      },
      cvsData: {
        title: "CVs Cargados",
        total: "Total",
        thisMonth: "Este mes",
        uploaded: "Cargados"
      },
      analysesData: {
        title: "Análisis IA",
        used: "Usados",
        remaining: "Restantes",
        thisMonth: "Este mes"
      },
      plan: {
        title: "Plan Actual",
        upgrade: "Actualizar"
      },
      ai: {
        title: "Funcionalidades IA",
        analysesDescription: "Comparador IA y resumen de CVs",
        resumeDescription: "Creación de fichas de candidatos vía IA",
        newBadge: "Nuevo",
        upcoming: "Próximas funcionalidades IA",
        comingSoon: "Próximamente"
      }
    },

    // Tabs
    tabs: {
      widgets: "Vista de Widgets",
      analytics: "Vista de Analíticas RH"
    },

    // Analytics
    analytics: {
      filters: {
        last7Days: "Últimos 7 días",
        last30Days: "Últimos 30 días",
        last90Days: "Últimos 90 días",
        allOffers: "Todas las ofertas"
      },
      error: {
        fetchFailed: "Error al cargar los datos"
      },
      export: {
        inProgress: "Exportación en curso...",
        success: "Exportación exitosa",
        error: "Error al exportar"
      },
      dragDrop: {
        hint: "Arrastra para reordenar",
        reorderSuccess: "Widgets reordenados"
      },
      empty: {
        title: "No hay datos disponibles",
        description: "Las métricas aparecerán aquí una vez que tenga datos."
      },
      candidates: {
        title: "Actividad de Candidaturas",
        subtitle: "Seguimiento de candidaturas recibidas",
        total: "Total",
        new: "Nuevas",
        avgPerOffer: "Promedio por oferta",
        applications: "Candidaturas",
        noData: "Sin candidaturas para este período"
      },
      offers: {
        title: "Actividad de Ofertas",
        subtitle: "Estado de sus ofertas de empleo",
        active: "Activas",
        closed: "Cerradas",
        cancelled: "Canceladas",
        popular: "Ofertas más populares",
        applications: "candidaturas",
        statusDistribution: "Distribución por estado",
        applicationsChart: "Candidaturas por oferta"
      },
      ai: {
        title: "IA y Procesamiento",
        subtitle: "Análisis automatizados",
        analyses: "Análisis",
        scored: "Puntuados",
        summaries: "Resúmenes",
        avgTime: "Tiempo prom.",
        processingEfficiency: "Eficiencia del procesamiento IA",
        usageTrend: "Tendencia de uso de IA",
        comparator: "Comparador",
        cvSummary: "Resumen CV",
        scoring: "Puntuación"
      },
      quality: {
        title: "Calidad y Puntuaciones",
        subtitle: "Distribución de perfiles",
        avgScore: "Puntuación promedio",
        highScore: "Puntuación alta",
        distribution: "Distribución de puntuaciones",
        candidates: "Candidatos",
        noData: "No hay análisis de puntuación disponible"
      },
      history: {
        title: "Historial y Trazabilidad",
        subtitle: "Acciones y eventos recientes",
        totalActions: "Acciones",
        exports: "Exportaciones",
        recent: "Actividades recientes",
        noData: "Sin actividad reciente",
        activityByUser: "Actividad por usuario",
        actionTypes: "Tipos de acciones"
      },
      actionTypes: {
        offer: "Ofertas",
        cv: "CVs",
        analysis: "Análisis",
        candidate: "Candidatos",
        kanban: "Kanban"
      },
      noData: "Sin datos"
    },

    // Activity tracking
    activity: {
      title: "Actividad reciente",
      noActivity: "Sin actividad",
      noActivities: "Sin actividad reciente",
      noRecentActivity: "Sin actividad reciente",
      newActionsHint: "Las nuevas acciones aparecerán aquí",
      count: "actividad",
      userFallback: "Usuario",
      fallback: "{{user}} realizó una acción",
      time: {
        now: "justo ahora",
        minutesAgo: "hace {{count}} minuto{{plural}}",
        hoursAgo: "hace {{count}} hora{{plural}}",
        daysAgo: "hace {{count}} día{{plural}}"
      },
      types: {
        offer_created: "Oferta creada",
        offer_updated: "Oferta actualizada", 
        offer_deleted: "Oferta eliminada",
        offer_published: "Oferta publicada",
        offer_unpublished: "Oferta despublicada",
        cv_uploaded: "CV cargado",
        cv_deleted: "CV eliminado",
        analysis_completed: "Análisis IA completado",
        analysis_reanalyzed: "Análisis IA re-ejecutado",
        result_exported: "Resultado exportado",
        user_login: "Inicio de sesión",
        settings_updated: "Configuración actualizada"
      },
      // Templates for activity descriptions
      templates: {
        // Ofertas
        offer_created: "creó la oferta \"{{title}}\"",
        offer_updated: "actualizó la oferta \"{{title}}\"",
        offer_deleted: "eliminó la oferta \"{{title}}\"",
        offer_published: "publicó la oferta \"{{title}}\"",
        offer_unpublished: "despublicó la oferta \"{{title}}\"",
        
        // CVs
        cv_uploaded: "cargó el CV \"{{filename}}\"",
        cv_deleted: "eliminó el CV \"{{filename}}\"",
        
        // Análisis
        analysis_completed: "completó el análisis de {{count}} CV(s)",
        analysis_reanalyzed: "re-analizó {{count}} CV(s)",
        
        // Candidatos
        candidate_created_manual: "creó manualmente el candidato \"{{name}}\"",
        candidate_shared_to_kanban: "compartió el candidato \"{{name}}\" al kanban",
        candidate_updated: "actualizó el candidato \"{{name}}\"",
        candidate_moved: "movió el candidato \"{{name}}\"",
        candidate_unshared_from_kanban: "retiró el candidato \"{{name}}\" del kanban",
        candidate_deleted: "eliminó el candidato \"{{name}}\"",
        
        // Candidaturas
        application_submitted: "Candidatura enviada por \"{{name}}\"",
        application_viewed: "vio la candidatura de \"{{name}}\"",
        application_status_changed: "cambió el estado de la candidatura de \"{{name}}\"",
        application_cv_downloaded: "descargó el CV de \"{{name}}\"",
        application_deleted: "eliminó la candidatura de \"{{name}}\"",
        application_note_added: "agregó una nota a la candidatura de \"{{name}}\"",
        application_note_updated: "actualizó una nota de la candidatura de \"{{name}}\"",
        application_note_deleted: "eliminó una nota de la candidatura de \"{{name}}\"",
        application_added_to_kanban: "agregó \"{{name}}\" al kanban",
        
        // Kanban
        kanban_column_created: "creó la columna \"{{name}}\"",
        kanban_column_updated: "actualizó la columna \"{{name}}\"",
        kanban_column_deleted: "eliminó la columna \"{{name}}\"",
        
        // Suscripciones
        subscription_upgraded: "actualizó al plan \"{{plan}}\"",
        subscription_downgraded: "cambió al plan \"{{plan}}\"",
        
        // Citas
        appointment_created: "creó una cita",
        appointment_confirmed: "confirmó la cita con \"{{name}}\"",
        appointment_cancelled: "canceló la cita con \"{{name}}\"",
        appointment_rescheduled: "reprogramó la cita con \"{{name}}\"",
        appointment_reminded: "envió recordatorio para la cita con \"{{name}}\"",
        availability_created: "agregó un horario de disponibilidad",
        availability_updated: "actualizó su disponibilidad",
        availability_deleted: "eliminó un horario de disponibilidad",
        send_appointment_invitation: "envió invitación de cita a \"{{name}}\"",
        appointment_booked_via_url: "cita reservada vía URL por \"{{name}}\"",
        booking_settings_updated: "actualizó la configuración de reservas",
        booking_settings_created: "configuró los parámetros de reserva",
        video_conference_configured: "configuró la videoconferencia {{provider}}",
        video_conference_updated: "actualizó la configuración de videoconferencia",
        video_conference_deleted: "eliminó la configuración de videoconferencia",
        holiday_created: "agregó día festivo{{global}}: {{name}}",
        holiday_updated: "actualizó el día festivo: {{name}}",
        holiday_deleted: "eliminó el día festivo: {{name}}",
        holidays_initialized: "inicializó {{count}} días festivos predeterminados",
        appointment_received: "nueva cita recibida",
        
        // Prueba
        test_performed: "realizó una prueba del sistema",
        
        // Configuración
        settings_cleanup_updated: "{{user}} actualizó la configuración de limpieza automática",
        cleanup_manual_started: "{{user}} inició limpieza manual",
        
        // Notas
        note_shared: "{{user}} compartió la nota \"{{title}}\" con {{userNames}}",
        note_unshared: "{{user}} dejó de compartir la nota \"{{title}}\"",
        
        // Configuración email/video
        create: "{{user}} creó {{actionDescription}}",
        update: "{{user}} actualizó {{actionDescription}}",
        delete: "{{user}} eliminó {{actionDescription}}",
        send: "{{user}} envió {{actionDescription}}"
      },
      time: {
        now: "Ahora mismo",
        minutesAgo: "Hace {{count}} minuto{{plural}}",
        hoursAgo: "Hace {{count}} hora{{plural}}",
        daysAgo: "Hace {{count}} día{{plural}}"
      },
      pagination: {
        info: "Página {{current}} de {{total}} • {{showing}} de {{total_activities}} actividades",
        previous: "Página anterior",
        next: "Página siguiente"
      }
    },

    // Notes modal in dashboard
    notes: {
      modal: {
        createTitle: "Crear nueva nota",
        editTitle: "Editar nota",
        titleLabel: "Título de la nota *",
        titlePlaceholder: "Ingrese el título de la nota",
        contentLabel: "Contenido *",
        contentPlaceholder: "Describa su nota en detalle...",
        tagsLabel: "Etiquetas",
        tagsPlaceholder: "Escriba y presione Enter para agregar etiquetas",
        tagsHelp: "Use etiquetas para organizar sus notas",
        charactersLabel: "caracteres",
        cancelButton: "Cancelar",
        createButton: "Crear nota",
        updateButton: "Actualizar nota",
        savingLabel: "Guardando...",
        errors: {
          titleRequired: "El título es requerido",
          titleTooLong: "El título no puede exceder 255 caracteres",
          contentRequired: "El contenido es requerido",
          contentTooLong: "El contenido no puede exceder 5000 caracteres",
          tagsTooLong: "Las etiquetas no pueden exceder 500 caracteres",
          saveError: "Error al guardar la nota",
          saveErrorGeneral: "Ocurrió un error al guardar"
        },
        messages: {
          createSuccess: "Nota creada exitosamente",
          updateSuccess: "Nota actualizada exitosamente"
        }
      }
    },

    // Analyzer section
    analyzer: {
      title: "Comparador IA",
      subtitle: "Analiza y clasifica tus CVs en relación a las ofertas de empleo gracias a la inteligencia artificial",
      noOffers: "Sin ofertas de empleo disponibles",
      noCvs: "Sin CVs disponibles",
      createOfferFirst: "Crea primero una oferta de empleo",
      uploadCvsFirst: "Carga primero algunos CVs",
      modes: {
        title: "Modo de análisis",
        manual: {
          title: "Modo Manual",
          description: "Ofertas no publicadas + CVs cargados manualmente"
        },
        submissions: {
          title: "Modo Candidaturas", 
          description: "Ofertas publicadas + CVs recibidos vía candidaturas"
        }
      },
      selection: {
        selectOffer: "Seleccionar una oferta",
        noOfferAvailable: "Sin ofertas disponibles",
        manualCvs: "CVs manuales ({{count}} seleccionados)",
        receivedCvs: "CVs recibidos para \"{{title}}\" ({{count}} seleccionados)",
        selectOfferFirst: "Selecciona una oferta para ver los CVs recibidos",
        analysisStatus: "• {{analyzed}} analizados, {{unanalyzed}} sin analizar",
        selectAll: "Seleccionar todo",
        deselectAll: "Deseleccionar todo",
        searchPlaceholder: "Buscar CVs...",
        analysisStatusFilter: "Estado del análisis:",
        filterAll: "Todos los CVs",
        filterUnanalyzed: "Sin analizar",
        filterAnalyzed: "Ya analizados",
        noCvsAvailable: "Sin CVs manuales disponibles",
        noCvsReceived: "Sin CVs recibidos para esta oferta",
        selectOfferToSeeCvs: "Selecciona una oferta publicada para ver los CVs recibidos"
      },
      cvLabels: {
        manual: "Manual",
        application: "Candidatura",
        textExtracted: "Texto extraído",
        textRequired: "Texto requerido",
        alreadyAnalyzed: "Ya analizado",
        published: "Publicada"
      },
      actions: {
        export: "Exportar (CSV)",
        startAnalysis: "Iniciar análisis IA",
        analyzing: "Análisis en progreso...",
        startAnalysisButton: "Iniciar análisis"
      },
      analysisInfo: {
        limitTitle: "Límite de análisis IA",
        limitDescription: "Puedes analizar máximo 25 CVs a la vez para garantizar un análisis de calidad óptima. Para analizar otros CVs de la misma oferta, realiza varios análisis sucesivos.",
        startTitle: "Iniciar análisis IA",
        startDescription: "Analizar {{count}}/25 CV(s) para la oferta \"{{title}}\"",
        startDescriptionEmpty: "Selecciona una oferta y CVs para comenzar"
      },
      results: {
        title: "Resultados del análisis (Clasificados por puntuación)",
        viewDetails: "Ver detalles",
        exportResults: "Exportar resultados",
        noResults: "Sin resultados de análisis",
        detailModalTitle: "Análisis detallado - {{name}}",
        globalScore: "Puntuación global",
        recommendation: "Recomendación",
        rank: "Rango: #{{rank}}",
        detailedAnalysis: "Análisis detallado",
        strengths: "Fortalezas", 
        weaknesses: "Puntos de mejora",
        skillsEvaluation: "Evaluación de habilidades",
        skillsRadarTitle: "Análisis comparativo de habilidades",
        close: "Cerrar"
      },
      stats: {
        analyzed: "CVs Analizados",
        recommended: "Recomendados",
        consider: "A Considerar",
        avgScore: "Puntuación Promedio"
      },
      analysis: {
        inProgress: "Análisis en progreso...",
        completed: "Análisis completado",
        progress: "Progreso",
        estimatedTime: "Tiempo estimado",
        analyzing: "Analizando",
        of: "de",
        cvs: "CVs",
        cancel: "Cancelar análisis"
      },
      reanalysisModal: {
        title: "Confirmar re-análisis",
        confirm: "Sí, rehacer análisis",
        cancel: "Cancelar"
      },
      errors: {
        dataLoadFailed: "Error al cargar los datos",
        cvsLoadFailed: "Error al cargar los CVs",
        selectOfferAndCvs: "Por favor selecciona una oferta y al menos un CV",
        maxCvsAtOnce: "Solo puedes analizar máximo 25 CVs a la vez",
        reanalysisError: "Error durante el re-análisis",
        analysisError: "Error durante el análisis",
        exportError: "Error durante la exportación",
        noOfferSelected: "Por favor selecciona una oferta de empleo",
        noCvsSelected: "Por favor selecciona al menos un CV",
        analysisLimitReached: "Límite de análisis IA alcanzado para este mes",
        upgradeRequired: "Actualización requerida"
      },
      warnings: {
        maxCvsLimit: "Puedes seleccionar máximo 25 CVs para un análisis"
      },
      messages: {
        limitedSelection: "Selección limitada a los primeros 25 CVs ({{count}} CVs disponibles)",
        analysisComplete: "¡Análisis completado! {{count}} CVs analizados",
        analysisCancelled: "Análisis cancelado",
        exportSuccess: "Resultados exportados con éxito",
        analysisStarted: "Análisis IA iniciado"
      }
    },

    // Results section
    results: {
      title: "Resultados de Análisis",
      subtitle: "Consulta y exporta tus resultados de análisis IA",
      noResults: "Sin resultados de análisis",
      runFirstAnalysis: "Realiza tu primer análisis IA para ver los resultados",
      filters: {
        all: "Todos los resultados",
        recent: "Recientes",
        byOffer: "Por oferta",
        byScore: "Por puntuación",
        searchPlaceholder: "Buscar en los resultados..."
      },
      sorting: {
        newest: "Más recientes",
        oldest: "Más antiguos",
        highestScore: "Puntuación más alta",
        lowestScore: "Puntuación más baja",
        alphabetical: "Alfabético"
      },
      actions: {
        view: "Ver detalles",
        export: "Exportar",
        delete: "Eliminar",
        compareAll: "Comparar todo",
        sendToKanban: "Enviar a Kanban",
        generateReport: "Generar informe"
      },
      export: {
        title: "Exportar resultados",
        format: "Formato de exportación",
        excel: "Excel (.xlsx)",
        csv: "CSV (.csv)",
        pdf: "PDF (.pdf)",
        includeDetails: "Incluir detalles del análisis",
        includeScores: "Incluir puntuaciones",
        includeRecommendations: "Incluir recomendaciones",
        exporting: "Exportando...",
        success: "Exportación exitosa",
        error: "Error durante la exportación"
      },
      scoreRanges: {
        excellent: "Excellent (90-100%)",
        good: "Bon (70-89%)",
        average: "Moyen (50-69%)",
        poor: "Faible (0-49%)"
      },
      details: {
        title: "Detalles del análisis",
        candidate: "Candidato",
        offer: "Oferta de empleo",
        overallScore: "Puntuación global",
        analysisDate: "Fecha del análisis",
        skillsMatch: "Coincidencia de habilidades",
        experienceMatch: "Coincidencia de experiencia",
        educationMatch: "Coincidencia de formación",
        strengths: "Fortalezas",
        weaknesses: "Puntos de mejora",
        recommendation: "Recomendación",
        aiAnalysis: "Analyse IA détaillée"
      },
      comparison: {
        title: "Comparaison des candidats",
        selectCandidates: "Sélectionner les candidats à comparer",
        compare: "Comparer",
        criteria: "Critères de comparaison",
        skills: "Compétences",
        experience: "Expérience",
        education: "Formation",
        overall: "Score global"
      },
      messages: {
        exported: "Résultats exportés avec succès",
        deleted: "Résultat supprimé avec succès",
        sentToKanban: "Candidat envoyé vers le Kanban"
      }
    },

    // Kanban page
   kanban: {
    title: "Tablero Kanban",
    subtitle: "Gestiona tus candidatos con un tablero visual interactivo",
    actions: {
      newColumn: "Nueva columna",
      column: "Columna",
      addCandidate: "Agregar candidato",
      editColumn: "Editar columna",
      deleteColumn: "Eliminar columna"
  },
  stats: {
    totalCandidates: "Total candidatos",
    activeColumns: "Columnas activas",
    visibleCandidates: "Candidatos visibles"
  },
  exitFullscreen: "Salir de pantalla completa",
  enterFullscreen: "Pantalla completa",
  searchPlaceholder: "Buscar un candidato...",
  filters: {
    allScores: "Todos los puntajes",
    above70: "Puntaje ≥ 70",
    above80: "Puntaje ≥ 80",
    above90: "Puntaje ≥ 90"
  },
  candidates: "candidatos",
  filtered: "filtrados",
  noCandidates: "Sin candidatos",
  noMatchingCandidates: "Sin candidatos coincidentes",
  tryAdjustingFilters: "Intenta ajustar tus filtros",
  candidate: "Candidato",
  analyzed: "Analizado",
  columns: {
    received: "Recibidos",
    screening: "Preselección",
    interview: "Entrevista",
    selected: "Seleccionados",
    hired: "Contratado"
  },
  candidateActions: {
    addNote: "Agregar una nota",
    viewProfile: "Ver perfil",
    downloadCV: "Descargar CV",
    moveToColumn: "Mover a",
    delete: "Eliminar"
  },
  noItems: "No hay candidatos en esta columna",
  dragHint: "Arrastra y suelta los candidatos entre las columnas",
  errors: {
    loadingBoard: "Error al cargar",
    loadingBoardToast: "Error al cargar el tablero",
    movingCandidate: "Error al mover",
    movingCandidateToast: "Error al mover el candidato",
    removingCandidate: "Error al eliminar",
    removingCandidateToast: "Error al eliminar el candidato",
    deletingCandidateToast: "Error al eliminar el candidato",
    deletingColumn: "Error al eliminar",
    deletingColumnToast: "Error al eliminar la columna",
    columnHasCandidates: "Esta columna contiene {{count}} candidato(s). Por favor muévelos antes de eliminar la columna."
  },
  messages: {
    candidateMoved: "Candidato movido con éxito",
    candidateRemoved: "Candidato eliminado del kanban con éxito",
    columnDeleted: "Columna eliminada con éxito",
    candidateDeleted: "Candidato eliminado con éxito"
  },
  tooltips: {
    addCandidate: "Agregar un candidato",
    editColumn: "Editar columna",
    deleteColumn: "Eliminar columna"
  },
  confirmations: {
    removeCandidate: {
      title: "Eliminar candidato",
      message: "¿Estás seguro de que deseas eliminar este candidato del kanban?\n(La ficha del candidato se conservará en los CVs)",
      confirm: "Eliminar",
      cancel: "Cancelar"
    },
    deleteCandidate: {
      title: "Eliminar candidato",
      message: "¿Estás seguro de que deseas eliminar permanentemente este candidato?",
      confirm: "Eliminar",
      cancel: "Cancelar"
    },
    deleteColumn: {
      title: "Eliminar columna",
      message: "¿Estás seguro de que deseas eliminar esta columna? Esta acción es irreversible.",
      confirm: "Eliminar",
      cancel: "Cancelar"
    }
  },
  columnModal: {
    createTitle: "Crear columna",
    editTitle: "Editar columna",
    nameLabel: "Nombre de la columna *",
    namePlaceholder: "Ej: En espera, En curso, Terminado...",
    colorLabel: "Color",
    previewLabel: "Vista previa",
    previewNamePlaceholder: "Nombre de la columna",
    previewDescription: "Los candidatos se mostrarán aquí",
    cancel: "Cancelar",
    create: "Crear",
    update: "Actualizar",
    saving: "Guardando...",
    saveError: "Error al guardar",
    createSuccess: "Columna creada con éxito",
    updateSuccess: "Columna actualizada"
  }
},



    // HR Management page
hrManagement: {
  title: "Gestión de RRHH",
  subtitle: "Gestiona las cuentas de usuarios de RRHH de tu equipo",
  noUsers: "No se encontraron usuarios",
  createFirst: "Empieza por agregar un usuario de RRHH",
  searchPlaceholder: "Buscar un usuario...",
  addUser: "Agregar un usuario de RRHH",
      
      // Dashboard stats
  stats: {
  hrUsers: "Usuarios de RRHH",
  totalAnalyses: "Análisis totales",
  createdOffers: "Ofertas creadas",
  uploadedCvs: "CVs subidos"
},
      
      // License information
license: {
  title: "Información de licencia",
  currentPackage: "Paquete actual",
  status: "Estado",
  expiration: "Expiración",
  active: "Activa",
  inactive: "Inactiva",
  notDefined: "No definido",
  notDefinedDate: "No definida"
},
      
      // Filters
 filters: {
  allStatuses: "Todos los estados",
  verified: "Verificados",
  unverified: "No verificados"
},
      
      // Table headers
  table: {
  user: "Usuario",
  email: "Correo electrónico",
  status: "Estado",
  createdDate: "Fecha de creación",
  actions: "Acciones"
},
      
      // User status
userStatus: {
  verified: "Verificado",
  unverified: "No verificado",
  hrUser: "Usuario de RRHH",
  nameNotDefined: "Nombre no definido"
},
      
      // Pagination
pagination: {
  previous: "Anterior",
  next: "Siguiente",
  showing: "Mostrando de",
  to: "a",
  of: "de",
  results: "resultados"
},
      
      // Search and filters help text
searchHelp: {
  modifySearch: "Intenta modificar tus criterios de búsqueda"
},
      
      // Modals
modals: {
  add: {
    title: "Agregar un usuario de RRHH",
    fullName: "Nombre completo",
    emailAddress: "Dirección de correo electrónico",
    password: "Contraseña",
    namePlaceholder: "Nombre del usuario",
    emailPlaceholder: "correo@ejemplo.com",
    passwordPlaceholder: "Contraseña (mín. 8 caracteres)",
    verificationNote: "Se enviará un correo de verificación al usuario",
    cancel: "Cancelar",
    create: "Crear usuario",
    creating: "Creando..."
  },
  edit: {
  title: "Editar usuario",
  fullName: "Nombre completo",
  emailAddress: "Dirección de correo electrónico",
  newPassword: "Nueva contraseña (opcional)",
  emailNote: "Cambiar el correo reiniciará la verificación",
  passwordPlaceholder: "Dejar en blanco para no modificar",
  cancel: "Cancelar",
  update: "Actualizar",
  updating: "Actualizando..."
},
delete: {
  title: "Eliminar usuario",
  confirmText: "¿Estás seguro de que deseas eliminar al usuario?",
  warningText: "Esta acción es irreversible. El usuario no podrá acceder más a su cuenta.",
  cancel: "Cancelar",
  delete: "Eliminar",
  deleting: "Eliminando..."
}
      },
      
      // Action tooltips
      tooltips: {
        resendVerification: "Reenviar correo de verificación",
        edit: "Editar",
        delete: "Eliminar"
      },
      
      // Toast messages
messages: {
  loadError: "Error al cargar los datos",
  fillAllFields: "Por favor completa todos los campos",
  fillNameEmail: "Por favor completa el nombre y el correo electrónico",
  passwordMinLength: "La contraseña debe tener al menos 8 caracteres",
  userCreated: "Usuario de RRHH creado con éxito",
  createError: "Error al crear el usuario",
  userUpdated: "Usuario actualizado con éxito",
  updateError: "Error al actualizar",
  userDeleted: "Usuario eliminado con éxito",
  deleteError: "Error al eliminar",
  alreadyVerified: "El usuario ya está verificado",
  verificationSent: "Correo de verificación enviado a",
  emailError: "Error al enviar el correo electrónico"
}
    },

    // Subscription page
    subscription: {
title: "Mi Suscripción",
subtitle: "Gestiona tu suscripción y consulta tu uso",
currentPlan: "Plan Actual",
usage: "Uso",
billing: "Facturación",
upgrade: "Actualizar",
downgrade: "Reducir plan",
cancel: "Cancelar suscripción",
renew: "Renovar",
changePaymentMethod: "Modificar método de pago",
billingHistory: "Historial de facturación",
nextBilling: "Próxima facturación",
autoRenewal: "Renovación automática",
      
      // Subscription details
subscriptionDetails: "Detalles de la Suscripción",
startDate: "Fecha de inicio",
endDate: "Fin de acceso",
autoRenewalActive: "⚡ Renovación automática activa",
changePlan: "Cambiar de plan",
exploreOtherPlans: "Explora nuestros otros planes para obtener más funciones",
perMonth: "/mes",
      
      // Status
 status: {
  active: "Activo",
  cancelled: "Cancelado",
  expired: "Expirado"
},
      
      // Auto renewal section
      autoRenewalTitle: "Renovación Automática Activa",
      autoRenewalDescription: "Su suscripción se renovará automáticamente el {{date}} por {{price}}. Los contadores de uso se reiniciarán en esa fecha.",
      
      // Cancelled renewal section
      cancelledRenewalTitle: "Renovación Automática Cancelada",
      cancelledRenewalDescription: "Su suscripción no se renovará automáticamente. Conserva el acceso hasta el {{date}}. Puede reactivar la renovación automática en cualquier momento.",
      
      // Actions
   cancelAutoRenewal: "Cancelar renovación automática",
activateAutoRenewal: "Activar renovación automática",
      
      // Usage section
refreshUsageData: "Actualizar los datos de uso",
used: "utilizado",
limitAlmostReached: "Límite casi alcanzado",
noDataAvailable: "No hay datos disponibles",
usageStatsWillAppear: "Las estadísticas de uso aparecerán aquí",
      
      // Plan change options
 otherPlansAvailable: "Otros Planes Disponibles",
discoverPlansEvolution: "Descubre nuestros planes para evolucionar según tus necesidades",
upgradeAction: "⬆️ ACTUALIZAR",
economical: "⬇️ ECONÓMICO",
      
      // Plan names
      planNames: {
        demo: "Demo Gratis",
        essential: "Esencial RH",
        enterprise: "Empresa"
      },
      
      // Plan descriptions
planDescriptions: {
  demo: "Descubre nuestra solución",
  essential: "Para equipos de RRHH en crecimiento",
  enterprise: "Solución empresarial completa"
},
      
      // Features
unlimitedAnalyses: "Análisis ilimitados",
analysesPerMonth: "análisis/mes",
hrUser: "usuario de RRHH",
hrUsers: "usuarios de RRHH",
jobOffers: "ofertas de empleo",
cvsPerMonth: "CVs/mes",
cvUploads: "CVs subidos",
aiAnalysesPerMonth: "análisis IA/mes",
aiResumesPerMonth: "resúmenes IA/mes",
appointments: "Citas",
customMinioStorage: "Almacenamiento MinIO personalizado",
videoAutomation: "Automatización URL reunión",
      
      // Plan change actions
upgradeToNext: "Pasar al siguiente nivel",
choosePlan: "Elegir este plan",
selectPlan: "Seleccionar",
validating: "Validando...",
      
      // Plan change information
planChangeTerms: "Términos de cambio de plan",
upgradesInfo: "<strong>Mejoras:</strong> Se aplican de inmediato con cálculo prorrateado",
downgradesInfo: "<strong>Reducciones:</strong> Entran en vigor al final del período actual",
countersInfo: "<strong>Contadores:</strong> Se reinician al cambiar de plan",
      
      // Usage statistics labels
usageLabels: {
  used: "utilizado(s)",
  allowed: "permitido(s)",
  excess: "en exceso"
},
      
      // Error messages
errors: {
  loadingSubscription: "Error al cargar la suscripción",
  planChangeValidation: "Error al validar el cambio de plan",
  cancellation: "Error al cancelar",
  reactivation: "Error al reactivar",
  downgradeImpossible: "No es posible realizar la degradación",
  currentUsageExceeds: "Su uso actual excede los límites del plan seleccionado:\n\n{{conflicts}}\n\nPor favor, elimine primero los elementos en exceso antes de proceder con la degradación.",
  understood: "Entendido"
},
      
      // Success messages
success: {
  autoRenewalCancelled: "Renovación automática cancelada con éxito",
  autoRenewalActivated: "Renovación automática activada con éxito"
},
      
      // Confirmation modal
      confirmModal: {
        cancelAutoRenewalTitle: "Cancelar la renovación automática",
        cancelAutoRenewalMessage: "¿Está seguro de que desea cancelar la renovación automática de su suscripción?\n\n• No habrá facturación automática futura\n• Acceso mantenido hasta el {{date}}\n• Posibilidad de reactivar la renovación en cualquier momento",
        cancelRenewal: "Cancelar la renovación",
        keepRenewal: "Mantener la renovación"
      },
      
      // Currency display
      pricesShownIn: "Precios mostrados en"
    },

    // Applications page
    applications: {
title: "Candidaturas",
subtitle: "Gestiona las candidaturas recibidas a través de tus ofertas publicadas",
noApplications: "No se recibió ninguna candidatura",
      
      // Published offers section
publishedOffers: {
  title: "Ofertas y candidaturas",
  noOffers: "Ninguna oferta publicada o con candidaturas",
  noOffersHint: "Publica una oferta para recibir candidaturas",
  copyUrl: "Copiar URL",
  urlCopied: "URL copiada al portapapeles",
  applicationCount: "candidatura",
  applicationCountPlural: "candidaturas",
  viewCount: "vista",
  viewCountPlural: "vistas",
  newApplications: "nueva",
  newApplicationsPlural: "nuevas",
  shortlistedApplications: "preseleccionada",
  shortlistedApplicationsPlural: "preseleccionadas",
  unpublished: "Despublicada"
},
      
      // Applications list section
 applicationsReceived: "Candidaturas recibidas",
selectOffer: "Selecciona una oferta",
selectOfferPrompt: "Selecciona una oferta publicada para ver las candidaturas",
noApplicationsForOffer: "No hay candidaturas para esta oferta",
noApplicationsHint: "Las nuevas candidaturas aparecerán aquí",
      
      // Filters and search
filters: {
  all: "Todas",
  allStatuses: "Todos los estados",
  new: "Nuevas",
  reviewed: "Revisadas",
  shortlisted: "Preseleccionadas",
  rejected: "Rechazadas",
  searchPlaceholder: "Buscar..."
},
      
      // Status badges
   status: {
  new: "Nuevo",
  reviewed: "Revisado",
  shortlisted: "Preseleccionado",
  rejected: "Rechazado"
},
      
      // Actions
actions: {
  viewDetails: "Ver detalles",
  previewCV: "Vista previa del CV",
  delete: "Eliminar candidatura",
  sendAppointment: "Enviar invitación de cita",
  markAsReviewed: "Marcar como revisado",
  shortlist: "Preseleccionar",
  reject: "Rechazar",
  manageCV: "Gestionar CV",
  addToKanban: "Añadir a Kanban",
  alreadyInKanban: "Ya está en Kanban"
},
      
      // Application modal
modal: {
  candidateInfo: "Información del candidato",
  currentStatus: "Estado actual",
  candidateMessage: "Mensaje del candidato",
  internalNotes: "Notas internas",
  addNote: "Agregar una nota interna sobre este candidato...",
  addNoteButton: "Agregar nota",
  noNotes: "No hay notas internas para esta candidatura",
  noNotesHint: "Agrega la primera nota para documentar tus intercambios",
  modified: "(modificado)",
  edit: "Editar",
  save: "Guardar",
  loadMoreNotes: "Ver más notas ({{count}} restantes)",
  appliedOn: "Candidatura enviada el {{date}}",
  source: "Fuente: {{source}}"
},
      
      // CV Preview modal
cvPreview: {
  title: "Vista previa del CV",
  docxFile: "Archivo DOCX",
  docxNotSupported: "La vista previa directa de archivos DOCX aún no está disponible.",
  extractedContent: "Contenido extraído:",
  textNotExtracted: "El texto aún no ha sido extraído de este archivo.",
  downloadFile: "Descargar archivo",
  oldDocFormat: "Archivo DOC (formato antiguo)",
  oldDocNotSupported: "La vista previa de archivos .DOC no es compatible.\nPor favor descarga el archivo para verlo.",
  unsupportedFormat: "Formato no compatible",
  unsupportedMessage: "Este tipo de archivo no puede ser previsualizado.",
  browserNotSupported: "Tu navegador no soporta la visualización de PDFs.",
  clickToDownload: "Haz clic aquí para descargar el archivo.",
  fileLabel: "Archivo:",
  sizeLabel: "Tamaño:",
  download: "Descargar",
  loadError: "Error al cargar el PDF"
},
      
      // Pagination
 pagination: {
  showing: "Mostrando de {{start}} a {{end}} de {{total}} candidaturas"
},
      
      // Confirmation dialogs
confirmations: {
  deleteTitle: "Eliminar candidatura",
  deleteMessage: "¿Estás seguro de que deseas eliminar la candidatura de {{name}}?\n\nEsta acción es irreversible y también eliminará el CV asociado.",
  deleteButton: "Eliminar",
  cancelButton: "Cancelar"
},
      
      // Delete application modal
      deleteApplicationModal: {
        title: "Eliminar Candidatura",
        message: "Está a punto de eliminar la candidatura de {{name}}.",
        activeAppointmentsNotice: "Este candidato tiene citas activas o pendientes. El CV se conservará automáticamente en la sección de Carga.",
        keepCvOption: "Eliminar solo la candidatura",
        keepCvDescription: "El CV se conservará y permanecerá accesible en la sección de Carga",
        deleteAllOption: "Eliminar candidatura y CV",
        deleteAllDescription: "Eliminar permanentemente la candidatura y el CV asociado",
        confirm: "Confirmar"
      },
      
      // Messages and errors
messages: {
  dataLoadError: "Error al cargar los datos",
  applicationLoadError: "Error al cargar la candidatura",
  statusUpdated: "Estado actualizado con éxito",
  statusUpdateError: "Error al actualizar el estado",
  applicationDeleted: "Candidatura eliminada con éxito",
  applicationDeletedCvKept: "Candidatura eliminada con éxito. El CV se ha conservado en la sección de Carga",
  deleteError: "Error al eliminar",
  noCVAssociated: "Ningún CV asociado a esta candidatura",
  cvLoadError: "Error al cargar el CV",
  noteLoadError: "Error al cargar las notas",
  noteAdded: "Nota añadida con éxito",
  noteAddError: "Error al añadir la nota",
  noteUpdated: "Nota actualizada con éxito",
  noteUpdateError: "Error al actualizar la nota",
  noteDeleted: "Nota eliminada con éxito",
  noteDeleteError: "Error al eliminar la nota",
  addedToKanban: "Candidato añadido a Kanban correctamente",
  alreadyInKanban: "Este candidato ya está en Kanban",
  addToKanbanError: "No se pudo añadir el candidato a Kanban",
  aiConfigMissing: "La configuración de IA no está definida. Añade tus claves API en Configuración > Desarrollador > Proveedores de IA.",
  aiInvalidToken: "Clave API de IA inválida. Verifica tu token en Configuración > Desarrollador > Proveedores de IA."
},
      
      // Legacy compatibility
candidate: {
  name: "Nombre",
  email: "Correo electrónico",
  phone: "Teléfono",
  appliedDate: "Fecha de candidatura",
  position: "Puesto"
}
    }
  },

  // Notes page
notes: {
  title: "Gestión de Notas",
  subtitle: "Crea, organiza y comparte tus notas con tu equipo",
  actions: {
    createNote: "Nueva nota",
    editNote: "Editar nota",
    deleteNote: "Eliminar nota",
    shareNote: "Compartir nota"
  },
 createNote: "Crear una nota",
editNote: "Editar nota",
deleteNote: "Eliminar nota",
noteTitle: "Título de la nota",
noteContent: "Contenido",
candidate: "Candidato",
offer: "Oferta de empleo",
tags: "Etiquetas",
priority: "Prioridad",
high: "Alta",
medium: "Media",
low: "Baja",
stats: {
  myNotes: "Mis notas",
  sharedNotes: "Notas compartidas",
  total: "Total"
    },
    search: {
      placeholder: "Buscar en las notas..."
    },
filters: {
  all: "Todas las notas",
  own: "Mis notas",
  shared: "Notas compartidas",
  byCandidate: "Por candidato",
  byOffer: "Por oferta",
  byPriority: "Por prioridad"
},
  results: {
  count: "{{count}} nota encontrada",
  countPlural: "{{count}} notas encontradas",
  found: "encontrada",
  foundPlural: "encontradas"
},
empty: {
  noNotesFound: "No se encontraron notas",
  noNotesYet: "Aún no hay notas",
  tryModifyingSearch: "Intenta modificar tus criterios de búsqueda",
  createFirstNote: "Crea tu primera nota para comenzar",
  createNote: "Crear una nota"
},
card: {
  shared: "Compartido",
  sharedBy: "por {{name}}",
  tooltips: {
    share: "Compartir",
    edit: "Editar",
    delete: "Eliminar"
  }
},
  messages: {
  loadError: "Error al cargar las notas",
  deleteSuccess: "Nota eliminada con éxito",
  deleteError: "Error al eliminar",
  deleteErrorGeneral: "Error al eliminar la nota",
  shareSuccess: "Nota compartida con éxito",
  shareError: "Error al compartir la nota",
  unshareSuccess: "Se detuvo el compartir de la nota",
  unshareError: "Error al detener el compartir",
  selectUsers: "Selecciona al menos un usuario"
},
delete: {
  title: "Eliminar nota",
  message: "¿Estás seguro de que deseas eliminar esta nota?\n\nEsta acción es irreversible.",
  confirmText: "Eliminar",
  cancelText: "Cancelar"
},
   modal: {
  createTitle: "Crear una nueva nota",
  editTitle: "Editar nota",
  titleLabel: "Título de la nota *",
  titlePlaceholder: "Ingresa el título de la nota",
  contentLabel: "Contenido *",
  contentPlaceholder: "Describe tu nota en detalle...",
  tagsLabel: "Etiquetas",
  tagsPlaceholder: "Escribe y presiona Enter para agregar etiquetas",
  tagsHelp: "Usa etiquetas para organizar tus notas",
  charactersLabel: "caracteres",
  cancelButton: "Cancelar",
  createButton: "Crear nota",
  updateButton: "Actualizar nota",
  savingLabel: "Guardando...",
  errors: {
    titleRequired: "El título es obligatorio",
    titleTooLong: "El título no puede superar los 200 caracteres",
    contentRequired: "El contenido es obligatorio",
    contentTooLong: "El contenido no puede superar los 5000 caracteres",
    tagsTooLong: "Las etiquetas no pueden superar los 500 caracteres",
    saveError: "Error al guardar la nota",
    saveErrorGeneral: "Ocurrió un error al guardar"
  },
  messages: {
    createSuccess: "Nota creada con éxito",
    updateSuccess: "Nota actualizada con éxito"
  }
},
  shareModal: {
    title: "Compartir nota",
    searchPlaceholder: "Buscar un miembro del equipo...",
    currentlyShared: "Actualmente compartido con:",
    teamMembers: "Miembros del equipo",
    noMembersFound: "No se encontraron miembros con esta búsqueda",
    noMembers: "No hay miembros en tu equipo",
    selected: "seleccionado",
    selectedPlural: "seleccionados",
    share: "Compartir",
    stopSharing: "Detener compartir",
    cancel: "Cancelar",
    sharing: "Compartiendo...",
    shared: "Compartido",
    stopSharingConfirm: {
      title: "Detener compartir",
      message: "¿Estás seguro de que deseas detener el compartir de esta nota? Todos los usuarios perderán el acceso.",
      confirmText: "Detener compartir",
      cancelText: "Cancelar"
    }
  },
  noNotes: "No se ha creado ninguna nota",
createFirst: "Crea tu primera nota"
  },

  // Offers section
 offers: {
  title: "Gestión de Ofertas",
  subtitle: {
    admin: "Gestiona las ofertas de tu equipo",
    hr: "Ofertas compartidas con tu equipo"
  },
  noOffers: "No se ha creado ninguna oferta de empleo",
  createFirst: "Crea tu primera oferta de empleo para comenzar",
  actions: {
    createNew: "Nueva oferta",
    create: "Crear una oferta",
    menu: "Menú de acciones",
    view: "Ver detalles",
    edit: "Editar",
    delete: "Eliminar",
    duplicate: "Duplicar",
    archive: "Archivar",
    publish: "Publicar la oferta",
    unpublish: "Retirar publicación",
    copyUrl: "Copiar URL"
  },
  status: {
    open: "Abierta",
    closed: "Cerrada",
    cancelled: "Cancelada",
    draft: "Borrador",
    archived: "Archivada"
  },
  fields: {
    title: "Título del puesto",
    client: "Cliente",
    location: "Ubicación",
    type: "Tipo de contrato",
    experience: "Experiencia requerida",
    skills: "Habilidades requeridas",
    salary: "Salario",
    description: "Descripción",
    requirements: "Requisitos",
    benefits: "Beneficios",
    deadline: "Fecha límite",
    createdAt: "Creada el",
    updatedAt: "Actualizada el"
  },
  labels: {
    published: "Publicado",
    team: "Equipo",
    requiredSkills: "Habilidades requeridas",
    createdOn: "Creada el",
    modifiedOn: "Modificada el",
    publishedOn: "Publicada el",
    view: "vista"
  },
  stats: {
    total: "Total",
    open: "Abiertas",
    closed: "Cerradas",
    cancelled: "Canceladas"
  },
  search: {
    placeholder: "Buscar por título, cliente o habilidades..."
  },
  filters: {
    title: "Filtros",
    search: "Búsqueda",
    status: "Estado",
    active: "Filtros activos",
    clearAll: "Restablecer todo",
    allStatuses: "Todos los estados",
    open: "Abiertas",
    closed: "Cerradas",
    cancelled: "Canceladas"
  },
  emptyState: {
    title: "No se encontraron ofertas",
    filterHint: "Intenta modificar tus filtros de búsqueda.",
    createHint: "Comienza creando tu primera oferta de empleo."
  },
  deleteModal: {
    title: "Eliminar oferta",
    message: "¿Estás seguro de que deseas eliminar esta oferta?\n\nEsta acción también eliminará todos los resultados de análisis asociados.",
    confirm: "Eliminar",
    cancel: "Cancelar"
  },
  unpublishModal: {
    title: "Retirar publicación",
    message: "¿Estás seguro de que deseas retirar esta oferta de la publicación?\n\nEl enlace público ya no estará disponible para los candidatos.",
    confirm: "Retirar",
    cancel: "Cancelar"
  },
  errors: {
    loadFailed: "Error al cargar las ofertas",
    deleteFailed: "Error al eliminar",
    hasDependencies: "Este CV no se puede eliminar porque está vinculado a otros elementos.",
    notFound: "CV no encontrado",
    publishFailed: "Error al publicar",
    unpublishFailed: "Error al retirar la publicación",
    createFailed: "Error al crear",
    updateFailed: "Error al modificar",
    usageLimitReached: "Límite de uso alcanzado"
  },
  messages: {
    createSuccess: "Oferta creada con éxito",
    updateSuccess: "Oferta modificada con éxito",
    deleteSuccess: "Oferta eliminada con éxito",
    publishSuccess: "¡Oferta publicada con éxito!",
    unpublishSuccess: "Oferta retirada de la publicación",
    urlCopied: "URL copiada al portapapeles"
  },
  modal: {
    createTitle: "Nueva oferta",
    editTitle: "Editar oferta",
    subtitle: "Completa la información para crear una oferta de empleo atractiva",
    steps: {
      basic: "Información básica",
      details: "Detalles del puesto",
      description: "Descripción"
    },
    step1: {
      title: "Información básica"
    },
    step2: {
      title: "Habilidades y requisitos"
    },
    step3: {
      title: "Descripción del puesto"
    }
  },
  form: {
    title: "Título de la oferta",
    titlePlaceholder: "Ej: Desarrollador React Senior",
    titleHint: "Un título claro y preciso atrae a más candidatos",
    client: "Cliente",
    clientPlaceholder: "Ej: TechCorp",
    location: "Ubicación",
    locationPlaceholder: "Ej: París, Remoto",
    duration: "Duración",
    durationPlaceholder: "Ej: 6 meses, Indefinido",
    status: "Estado",
    statusOpen: "Abierta",
    statusClosed: "Cerrada",
    statusCancelled: "Cancelada",
    requiredSkills: "Habilidades requeridas",
    skillsPlaceholder: "Escribe una habilidad y presiona Enter",
    skillsHint: "Escribe una habilidad y presiona Enter o coma para añadirla",
    addSkill: "Agregar",
    description: "Descripción completa",
    descriptionPlaceholder: "Describe el puesto, responsabilidades, entorno laboral...",
    descriptionHint: "Una descripción detallada ayuda a los candidatos a comprender mejor el puesto",
    preview: "Vista previa de la oferta",
    previous: "Anterior",
    next: "Siguiente",
    cancel: "Cancelar",
    create: "Crear",
    update: "Editar",
    creating: "Creando...",
    updating: "Modificando..."
  },
  validation: {
    titleRequired: "El título es obligatorio",
    skillsRequired: "Se requiere al menos una habilidad",
    descriptionRequired: "La descripción es obligatoria"
  }
},

  // CVs section
cvs: {
  title: "Gestión de CVs",
  subtitle: {
    admin: "CVs compartidos con tu equipo de RRHH",
    hr: "CVs accesibles para todo tu equipo"
  },
  noCvs: "No se ha subido ningún CV",
  uploadFirst: "Sube tu primer CV para comenzar el análisis",
  upload: {
    title: "Subir CVs",
    dragDrop: "Arrastra y suelta tus archivos aquí",
    or: "o",
    clickToSelect: "Haz clic para seleccionar",
    orDragDrop: "o arrastra y suelta tus archivos aquí",
    pdfOnly: "Solo archivos PDF o DOCX, hasta 10MB por archivo",
    supportedFormats: "Formatos compatibles: PDF, DOCX",
    maxSize: "Tamaño máximo: 10 MB por archivo",
    maxFiles: "Máximo 10 archivos a la vez",
    maxFilesLimit: "Máximo 50 archivos por carga",
    uploading: "Subiendo...",
    processing: "Procesando archivos...",
    clickToSelectFiles: "Haz clic para seleccionar tus archivos",
    selectedFiles: "Archivos seleccionados",
    clearSelection: "Eliminar todo",
    startExtraction: "Subir + Extraer texto",
    processingExtraction: "Subida + Extracción...",
    success: "CVs subidos con éxito",
    error: "Error al subir los archivos"
  },
  sections: {
    byOffer: "CVs por Oferta Publicada",
    manual: "CVs Subidos Manualmente",
    searchResults: "Resultados de búsqueda",
    all: "Todos los CVs",
    applications: "CVs de candidaturas",
    applicationsUnlinked: "CVs de candidaturas (sin oferta)",
    manualFull: "CVs Subidos Manualmente"
  },
  tabs: {
    offers: "Banco de CVs por ofertas publicadas",
    manual: "Banco de CVs subidos manualmente"
  },
  filters: {
    title: "Filtros",
    search: "Búsqueda",
    type: "Tipo",
    origin: "Origen",
    offer: "Oferta",
    active: "Filtros activos",
    clearAll: "Restablecer todo",
    all: "Todos los CVs",
    recent: "Recientes",
    analyzed: "Analizados",
    notAnalyzed: "No analizados",
    searchPlaceholder: "Buscar por nombre del candidato...",
    allTypes: "Todos los tipos",
    allOrigins: "Todos los orígenes",
    allOffers: "Todas las ofertas",
    manualUpload: "Carga manual",
    application: "Candidatura"
  },
  actions: {
    view: "Ver CV",
    download: "Descargar",
    delete: "Eliminar",
    analyze: "Analizar",
    editCandidate: "Ver/Editar ficha",
    generateProfile: "Generar perfil del candidato",
    addToKanban: "Agregar al Kanban",
    removeFromKanban: "Quitar del Kanban",
    sendAppointment: "Enviar invitación de cita",
    upload: "Subir CVs",
    preview: "Vista previa del CV",
    aiResume: "Resumen AI + creación de ficha de candidato"
  },
  fields: {
    candidate: "Candidato",
    filename: "Nombre del archivo",
    uploadDate: "Fecha de subida",
    fileSize: "Tamaño",
    status: "Estado",
    lastAnalysis: "Último análisis",
    score: "Puntuación"
  },
  status: {
    uploaded: "Subido",
    processing: "Procesando",
    analyzed: "Analizado",
    error: "Error"
  },
  candidateProfile: {
    title: "Perfil del Candidato",
    generateWith: "Generar con IA",
    generating: "Generando...",
    generated: "Perfil generado con éxito",
    summary: "Resumen profesional",
    experience: "Experiencia",
    skills: "Habilidades",
    education: "Formación",
    languages: "Idiomas",
    contact: "Contacto"
  },
  confirmDelete: "¿Estás seguro de que deseas eliminar este CV?",
  labels: {
    team: "Equipo",
    selectedFromApplication: "CV seleccionado desde la candidatura",
    receivedViaApplication: "CV recibido vía candidatura pública",
    receivedFromApplications: "CVs recibidos vía candidaturas públicas",
    uploadedByTeam: "CVs subidos por tu equipo",
    offer: "Oferta",
    application: "Candidatura",
    manual: "Manual",
    candidateCardCreated: "Ficha creada",
    sharedToKanban: "Compartido en el kanban"
  },
  stats: {
    total: "Total",
    documents: "PDF/DOCX",
    manual: "Carga manual",
    applications: "Candidaturas"
  },
  search: {
    placeholder: "Buscar por nombre del archivo..."
  },
  viewMode: {
    label: "Modo de visualización",
    sections: "Secciones",
    grouped: "Por oferta",
    list: "Lista",
    expandAll: "Expandir todo",
    collapseAll: "Colapsar todo"
  },
  emptyState: {
    title: "No se encontraron CVs",
    filterHint: "Intenta modificar tus filtros de búsqueda.",
    uploadHint: "Comienza subiendo tus primeros CVs."
  },
  deleteModal: {
    title: "Eliminar CV",
    message: "¿Estás seguro de que deseas eliminar el CV \"{{filename}}\"?\n\nEsta acción es irreversible.",
    confirm: "Eliminar",
    cancel: "Cancelar",
    warnings: {
      hasKanbanCard: "⚠️ Esta ficha de candidato está compartida en el kanban. Eliminar el CV también eliminará la ficha del candidato y detendrá su seguimiento en el kanban.",
      hasAppointments: "⚠️ El candidato de este CV tiene citas activas. ¿Estás seguro de que deseas eliminar su CV?"
    }
  },
  candidateDeleteModal: {
    title: "Eliminar ficha del candidato",
    message: "¿Estás seguro de que deseas eliminar esta ficha de candidato?\n\nTodos los datos asociados se perderán de forma permanente.",
    confirm: "Eliminar ficha",
    cancel: "Cancelar"
  },
  errors: {
    loadFailed: "Error al cargar los CVs",
    uploadFailed: "Error al subir",
    uploadFailedAll: "Error al cargar los archivos",
    deleteFailed: "Error al eliminar",
    downloadFailed: "Error al descargar el CV",
    analysisFailed: "Error durante el análisis",
    shareFailed: "Error al compartir",
    unshareFailed: "Error al retirar el compartir",
    invalidFileType: "⚠️ Solo se aceptan archivos PDF o DOCX. Convierte tus documentos antes de subirlos.",
    fileTooLarge: "El archivo es demasiado grande. Tamaño máximo: 10MB.",
    tooManyFiles: "Demasiados archivos seleccionados. Reduce la cantidad.",
    noValidFiles: "No se detectaron archivos PDF/DOCX válidos",
    noValidSelected: "No se seleccionó ningún archivo PDF/DOCX válido",
    previewUnsupported: "La vista previa solo está disponible para archivos PDF. Descarga el archivo para verlo."
  },
  warnings: {
    extractTextFirst: "Por favor extrae el texto del CV primero"
  },
  messages: {
    uploadSuccess: "{{count}} CV(s) subido(s) con éxito",
    duplicateFile: "El documento \"{{filename}}\" ya existe. Si es una actualización, elimina el archivo anterior o cambia su nombre.",
    noNewFiles: "No se ha añadido ningún CV nuevo; todos los archivos ya existían.",
    deleteSuccess: "CV eliminado con éxito",
    candidateCreated: "Ficha de candidato creada con éxito",
    candidateDeleted: "Ficha de candidato eliminada con éxito",
    sharedToKanban: "Candidato compartido con el kanban con éxito",
    unsharedFromKanban: "Candidato retirado del kanban con éxito",
    uploaded: "CV subido con éxito",
    deleted: "CV eliminado con éxito",
    profileGenerated: "Perfil de candidato generado con éxito"
  }
},

  // Security & Privacy Page
security: {
  title: "Seguridad y Privacidad",
  subtitle: "Tus datos están seguros",

  tabs: {
    dataHosting: {
      label: "Alojamiento de Datos",
      description: "Dónde se almacenan tus datos"
    },
    gdpr: {
      label: "RGPD y Cumplimiento",
      description: "Cumplimiento normativo"
    },
    dataUsage: {
      label: "Uso de Datos",
      description: "Cómo usamos tus datos"
    },
    userControl: {
      label: "Control del Usuario",
      description: "Gestión de tus datos"
    },
    aiSecurity: {
      label: "IA y Seguridad",
      description: "Protección durante el análisis IA"
    }
  },

  features: {
    encryption: {
      title: "Cifrado de extremo a extremo",
      description: "Todos tus datos están cifrados con AES-256"
    },
    gdprCompliance: {
      title: "Cumplimiento RGPD",
      description: "Cumplimiento total con la normativa europea"
    },
    secureHosting: {
      title: "Alojamiento seguro",
      description: "Datos alojados en la Unión Europea"
    },
    rightToForget: {
      title: "Derecho al olvido",
      description: "Eliminación completa de tus datos en cualquier momento"
    }
  },

  hero: {
    badge: "Seguridad y Privacidad",
    title: "Tus datos están seguros",
    subtitle: "Descubre cómo protegemos tus datos personales y respetamos tu privacidad con los más altos estándares de seguridad."
  },

  overview: {
    title: "Seguridad de nivel empresarial",
    subtitle: "Candio implementa las mejores prácticas de seguridad para proteger tus datos sensibles y respetar tu confidencialidad."
  },

  detailedInfo: {
    title: "Información detallada",
    subtitle: "Explora en detalle cómo gestionamos, protegemos y respetamos tus datos personales."
  },

  dataHosting: {
    serverLocation: {
      title: "Ubicación de los servidores",
      description: "Todos tus datos están alojados exclusivamente en centros de datos situados en la <strong>Unión Europea</strong>, garantizando el cumplimiento de las leyes europeas de protección de datos."
    },
    infrastructure: {
      title: "Infraestructura",
      items: [
        "Centros de datos certificados ISO 27001",
        "Redundancia geográfica múltiple",
        "Copias de seguridad automáticas diarias",
        "Supervisión 24/7 de los sistemas"
      ]
    },
    encryption: {
      title: "Cifrado",
      items: [
        "Cifrado AES-256 en reposo",
        "TLS 1.3 para transmisiones",
        "Rotación de claves de cifrado",
        "Acceso seguro mediante autenticación doble"
      ]
    }
  },

  gdpr: {
    compliance: {
      title: "Cumplimiento total con el RGPD",
      description: "Candio cumple plenamente con el Reglamento General de Protección de Datos (RGPD) y respeta todos tus derechos como usuario."
    },
    rights: {
      title: "Tus derechos bajo el RGPD",
      access: {
        title: "Derecho de acceso",
        description: "Consultar todos tus datos personales"
      },
      rectification: {
        title: "Derecho de rectificación",
        description: "Corregir tu información personal"
      },
      erasure: {
        title: "Derecho al olvido",
        description: "Eliminar tus datos de forma definitiva"
      },
      portability: {
        title: "Derecho a la portabilidad",
        description: "Exportar tus datos en un formato estándar"
      },
      objection: {
        title: "Derecho de oposición",
        description: "Oponerte al tratamiento de tus datos"
      },
      restriction: {
        title: "Derecho a la limitación",
        description: "Limitar el tratamiento de tus datos"
      }
    },
    processingTimes: {
      title: "Plazos de procesamiento",
      acknowledgment: "Acuse de recibo",
      standard: "Procesamiento estándar",
      maximum: "Plazo legal máximo",
      hours24: "24h",
      days7: "7 días",
      days30: "30 días"
    }
  },

  dataUsage: {
    exclusive: {
      title: "Uso exclusivo y transparente",
      description: "Tus datos <strong>nunca se venden, comparten ni utilizan para otros fines</strong> que los estrictamente necesarios para el funcionamiento de Candio."
    },
    whatWeDo: {
      title: "Qué hacemos con tus datos",
      analysis: {
        title: "Análisis y comparación de CVs",
        description: "Procesamiento IA para clasificar y analizar candidaturas"
      },
      management: {
        title: "Gestión de tu cuenta",
        description: "Autenticación, facturación y soporte al cliente"
      },
      improvement: {
        title: "Mejora del servicio",
        description: "Estadísticas anonimizadas para optimizar nuestros algoritmos"
      }
    },
    whatWeDont: {
      title: "Lo que NUNCA hacemos",
      dataSale: {
        title: "Venta de datos",
        description: "Tus datos nunca se venden a terceros"
      },
      commercialSharing: {
        title: "Intercambio comercial",
        description: "No compartimos datos con socios comerciales"
      },
      advertising: {
        title: "Uso publicitario",
        description: "No realizamos perfiles para publicidad dirigida"
      }
    }
  },

  userControl: {
    fullControl: {
      title: "Control total de tus datos",
      description: "Mantienes control total sobre tus datos personales con funcionalidades integradas directamente en tu cuenta."
    },
    features: {
      title: "Funciones disponibles en tu cuenta",
      export: {
        title: "Exportar mis datos",
        description: "Descarga todos tus datos en formato JSON",
        location: "Disponible en Configuración → Datos personales"
      },
      delete: {
        title: "Eliminar mi cuenta",
        description: "Eliminación definitiva de todos tus datos",
        location: "Disponible en Configuración → Gestión de cuenta"
      },
      view: {
        title: "Ver mis datos",
        description: "Consulta toda la información almacenada",
        location: "Disponible en Configuración → Privacidad"
      },
      preferences: {
        title: "Gestionar preferencias",
        description: "Controla el uso de tus datos",
        location: "Disponible en Configuración → Preferencias"
      }
    },
    deletionProcess: {
      title: "Proceso de eliminación de datos",
      step1: {
        title: "Solicitud de eliminación",
        description: "A través de tu cuenta o contactándonos"
      },
      step2: {
        title: "Verificación de identidad",
        description: "Confirmación segura de tu identidad"
      },
      step3: {
        title: "Eliminación inmediata",
        description: "Borrado definitivo en un máximo de 24h"
      }
    }
  },

  aiSecurity: {
    protection: {
      title: "IA segura y privada",
      description: "Utilizamos modelos de IA avanzados para analizar tus CVs, pero tus datos permanecen <strong>privados y protegidos</strong> en todo momento."
    },
    models: {
      title: "Modelos de IA utilizados",
      openai: {
        title: "OpenAI GPT-4",
        description: "Modelo principal para análisis semántico de CVs y comparación con ofertas de empleo.",
        certification: "Certificado SOC 2 Tipo II"
      },
      local: {
        title: "Procesamiento local",
        description: "Extracción de texto y preprocesamiento realizados en nuestros servidores seguros.",
        guarantee: "Sin almacenamiento en proveedores de IA"
      }
    },
    protectionMeasures: {
      title: "Protección de datos durante el análisis IA",
      anonymization: {
        title: "Anonimización automática",
        description: "Los datos personales identificables se ocultan antes del análisis IA"
      },
      encryption: {
        title: "Transmisión cifrada",
        description: "Todas las comunicaciones con los servicios IA están cifradas de extremo a extremo"
      },
      noStorage: {
        title: "Sin almacenamiento externo",
        description: "Los proveedores de IA no conservan copias de tus datos"
      },
      realtime: {
        title: "Procesamiento en tiempo real",
        description: "Análisis inmediato sin almacenamiento temporal en terceros"
      }
    },
    purposes: {
      title: "Finalidades del uso de IA",
      semantic: {
        title: "Análisis semántico",
        description: "Comprensión del contenido de CVs y ofertas de empleo"
      },
      classification: {
        title: "Clasificación",
        description: "Ordenación de candidatos por relevancia y adecuación"
      },
      synthesis: {
        title: "Síntesis",
        description: "Generación de resúmenes y recomendaciones personalizadas"
      }
    }
  },

  contact: {
    title: "¿Preguntas sobre seguridad?",
    subtitle: "Nuestro equipo de seguridad está disponible para responder todas tus preguntas sobre la protección de tus datos.",
    teamButton: "Contactar al equipo de seguridad",
    emailButton: "security@lediteur.club"
  }
},

  // Job Application Page
 jobApplication: {
  loading: "Cargando...",
  error: {
    notFound: "Oferta no encontrada",
    notFoundDescription: "Esta oferta no existe o ya no está disponible.",
    general: "Error al enviar",
    title: "Se produjo un error",
    message: "No se puede cargar esta oferta. Por favor, inténtalo de nuevo más tarde."
  },
  success: {
    title: "¡Candidatura enviada!",
    description: "Gracias por tu postulación. Hemos recibido tu CV y nos pondremos en contacto contigo pronto.",
    canClose: "Puedes cerrar esta página."
  },
  company: {
    website: "Sitio web",
    about: "Sobre la empresa"
  },
  offer: {
    views: "vistas",
    publishedOn: "Publicada el",
    jobDescription: "Descripción del puesto",
    requiredSkills: "Habilidades requeridas"
  },
  form: {
    title: "Postular ahora",
    subtitle: "Únete a nuestro equipo en solo unos clics",
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Correo electrónico",
    phone: "Teléfono",
    message: "Mensaje (opcional)",
    messagePlaceholder: "¿Por qué estás interesado en este puesto?",
    cv: "CV * (PDF o DOCX - máx. 10MB)",
    cvPlaceholder: "Haz clic o arrastra tu CV aquí",
    cvUploadText: "Arrastra tu CV aquí o haz clic para buscar",
    cvFileTypes: "PDF o DOCX (máx. 10MB)",
    required: "*",
    submit: "Enviar mi candidatura",
    submitting: "Enviando...",
    privacy: "Al enviar este formulario, aceptas que tus datos sean tratados en el marco de esta candidatura."
  },
  validation: {
    firstNameRequired: "El nombre es obligatorio",
    lastNameRequired: "El apellido es obligatorio",
    emailRequired: "El correo electrónico es obligatorio",
    emailInvalid: "Correo electrónico inválido",
    cvRequired: "El CV es obligatorio",
    cvFileTypeError: "Solo se aceptan archivos PDF o DOCX. Por favor convierte tu documento antes de subirlo.",
    cvFileSizeError: "El archivo no debe superar los 10MB"
  },
  dateFormat: {
    options: {
      day: "numeric",
      month: "long",
      year: "numeric"
    }
  },
  steps: {
    step: "Paso",
    of: "de",
    personalInfo: "Información personal",
    yourCV: "Tu CV",
    motivationMessage: "Mensaje de motivación"
  },
  whyJoinUs: {
    title: "¿Por qué unirse a nosotros?",
    careerGrowth: "Crecimiento profesional",
    careerGrowthDesc: "Oportunidades de crecimiento y formación continua",
    dynamicTeam: "Equipo dinámico",
    dynamicTeamDesc: "Ambiente colaborativo y de apoyo",
    innovativeProjects: "Proyectos innovadores",
    innovativeProjectsDesc: "Trabaja con tecnologías de vanguardia",
    competitiveBenefits: "Beneficios competitivos",
    competitiveBenefitsDesc: "Salario atractivo y beneficios"
  },
  placeholders: {
    firstName: "Juan",
    lastName: "Pérez",
    email: "juan.perez@email.com",
    phone: "+34 612 345 678",
    motivation: "Cuéntanos sobre tu motivación para este puesto..."
  },
  buttons: {
    continue: "Continuar",
    back: "Atrás",
    remove: "Eliminar",
    backToHome: "Volver al inicio"
  },
  summary: {
    title: "Resumen de tu candidatura",
    name: "Nombre",
    email: "Correo electrónico",
    phone: "Teléfono",
    cv: "CV"
  },
  expired: {
    title: "Oferta expirada",
    message: "Esta oferta de trabajo ya no está disponible o ha sido retirada por el empleador."
  }
},

  // Messages and Notifications
 messages: {
  success: {
    saved: "Configuración guardada con éxito",
    updated: "Actualizado con éxito",
    deleted: "Eliminado con éxito",
    uploaded: "Archivo subido con éxito",
    sent: "Mensaje enviado con éxito"
  },
  errors: {
    general: "Ocurrió un error. Por favor, inténtalo de nuevo.",
    network: "Error de red. Por favor, verifica tu conexión.",
    unauthorized: "No estás autorizado para realizar esta acción.",
    notFound: "El recurso solicitado no fue encontrado.",
    serverError: "Error del servidor. Inténtalo más tarde."
  },
  confirmations: {
    delete: "¿Estás seguro de que deseas eliminar este elemento?",
    unsavedChanges: "Tienes cambios no guardados. ¿Estás seguro de que deseas salir?",
    logout: "¿Estás seguro de que deseas cerrar sesión?"
  }
},

  // Email Templates
  emails: {
    verification: {
      subject: "Verifica tu cuenta de Candio",
      title: "¡Bienvenido a Candio!",
      subtitle: "Tu cuenta está casi lista, solo falta un paso",
      description: "Matching de CVs con IA en un clic",
      thankYou: "Gracias por registrarte en Candio",
      instruction: "Para activar tu cuenta y comenzar a usar nuestros servicios, por favor haz clic en el botón de abajo:",
      buttonText: "Verificar mi cuenta",
      warning: "Importante: Este enlace expira en 24 horas por tu seguridad.",
      alternativeText: "Si el botón no funciona:",
      noAccount: "Si no creaste esta cuenta, puedes ignorar este email con seguridad.",
      copyright: "© 2025 Candio - Todos los derechos reservados"
    },
    contact: {
      subjectPrefix: "[Candio Contacto]",
      newMessage: "Nuevo Mensaje de Contacto",
      details: "Detalles del Contacto",
      name: "Nombre:",
      email: "Email:",
      subject: "Asunto:",
      message: "Mensaje:",
      replyText: "Para responder, simplemente haga clic en 'Responder' en su cliente de correo.",
      autoText: "Email enviado automáticamente desde Candio"
    },
    application: {
      subject: "Nueva candidatura para {{offerTitle}}",
      title: "Nueva candidatura recibida",
      offerLabel: "Oferta",
      candidateLabel: "Candidato",
      emailLabel: "Correo electrónico",
      phoneLabel: "Teléfono", 
      messageLabel: "Mensaje",
      noMessage: "Sin mensaje específico",
      viewAllApplicationsButton: "📋 Ver todas las candidaturas",
      dashboardFooter: "Inicie sesión en su panel de control para ver más detalles y gestionar esta candidatura."
    },
    appointments: {
      invitation: {
        subject: "Invitación a entrevista - {{offerTitle}}",
        title: "Invitación a entrevista",
        greeting: "Hola {{candidate_name}}",
        message: "Nos complace invitarle a una entrevista tras su candidatura para el puesto de \"{{offerTitle}}\".\n\nNos gustaría discutir con usted su trayectoria y motivaciones para este puesto. Esta entrevista también nos permitirá presentarle nuestra empresa y responder a sus preguntas.\n\nPuede elegir un horario que le convenga haciendo clic en el botón de abajo.",
        bookAppointment: "Reservar cita",
        meetingType: "Tipo de reunión",
        online: "En línea",
        physical: "Presencial",
        videoLinkNote: "El enlace de videoconferencia se le enviará después de confirmar su cita.",
        instructions: "Haga clic en el botón de arriba para acceder a nuestro calendario y elegir un horario que le convenga.",
        phone: "Tel",
        email: "Email",
        allRightsReserved: "Todos los derechos reservados.",
        website: "Sitio web",
        contact: "Contacto",
        emailTitle: "Notificación",
        dateLocale: "es-ES"
      },
      confirmation: {
        subject: "Confirmación de cita",
        greeting: "Hola {{prenom}}",
        message: "Nos complace confirmar su cita.",
        date: "Fecha",
        time: "Hora",
        with: "Con",
        type: "Tipo",
        meetingLink: "Enlace de la reunión",
        clickToJoin: "Haga clic aquí para unirse",
        linkWillBeSent: "El enlace se le enviará pronto",
        address: "Dirección",
        importantNote: "Nota importante",
        onlineInstructions: "Asegúrese de tener una conexión a internet estable y un lugar tranquilo para su entrevista.",
        regards: "Atentamente"
      },
      cancellation: {
        subject: "Cancelación de cita",
        greeting: "Hola {{prenom}}",
        message: "Le informamos que su {{status_rendez_vous}} cita programada para el {{date}} a las {{heure}} ha sido cancelada.",
        reason: "Motivo",
        apology: "Le pedimos disculpas por las molestias ocasionadas.",
        reschedule: "Si desea reprogramar una cita, no dude en contactarnos."
      }
    }
  },

  // Analyzer Page
  analyzer: {
    title: "Comparador IA",
    subtitle: "Analiza y clasifica tus CVs en función de las ofertas de empleo utilizando inteligencia artificial",
    
    errors: {
      dataLoadFailed: "Error al cargar los datos",
      cvsLoadFailed: "Error al cargar los CVs",
      selectOfferAndCvs: "Por favor selecciona una oferta y al menos un CV",
      maxCvsAtOnce: "Solo puedes analizar un máximo de 25 CVs a la vez",
      analysisError: "Error durante el análisis",
      reanalysisError: "Error durante el re-análisis",
      exportError: "Error durante la exportación"
    },
    
    warnings: {
      maxCvsLimit: "Puedes seleccionar un máximo de 25 CVs para análisis"
    },
    
    messages: {
      limitedSelection: "Selección limitada a los primeros 25 CVs ({{count}} CVs disponibles)",
      analysisComplete: "¡Análisis completo! {{count}} CVs analizados",
      analysisCancelled: "Análisis cancelado",
      exportSuccess: "Resultados exportados con éxito"
    },
    
    reanalysisModal: {
      title: "Confirmar re-análisis",
      confirm: "Sí, rehacer análisis",
      cancel: "Cancelar",
      exactCombinationMessage: "Esta combinación exacta ({{count}} CVs) ya ha sido analizada contra esta oferta el {{date}} a las {{time}}.\n\n¿Está seguro de que desea rehacer este análisis idéntico?",
      partialOverlapMessage: "{{analyzed}} CV(s) de {{total}} ya han sido analizados contra esta oferta (pero no en esta combinación exacta).\n\nEsta nueva combinación permitirá una clasificación comparativa global.\n\n¿Está seguro de que desea continuar con este análisis?"
    },
    
    modes: {
      title: "Modo de análisis",
      manual: {
        title: "Modo Manual",
        description: "Ofertas no publicadas + CVs subidos manualmente"
      },
      submissions: {
        title: "Modo Candidaturas",
        description: "Ofertas publicadas + CVs recibidos via candidaturas"
      }
    },
    
    stats: {
      analyzed: "CVs Analizados",
      recommended: "Recomendados",
      consider: "A Considerar",
      avgScore: "Puntuación Media"
    },
    
    selection: {
      selectOffer: "Seleccionar una oferta",
      noOfferAvailable: "Ninguna oferta disponible",
      manualCvs: "CVs manuales ({{count}} seleccionados)",
      receivedCvs: "CVs recibidos para \"{{title}}\" ({{count}} seleccionados)",
      selectOfferFirst: "Selecciona una oferta para ver los CVs recibidos",
      analysisStatus: "• {{analyzed}} analizados, {{unanalyzed}} no analizados",
      deselectAll: "Deseleccionar todo",
      selectAll: "Seleccionar todo",
      searchPlaceholder: "Buscar CVs...",
      analysisStatusFilter: "Estado del análisis:",
      filterAll: "Todos los CVs",
      filterUnanalyzed: "No analizados",
      filterAnalyzed: "Ya analizados",
      selectOfferToSeeCvs: "Selecciona una oferta publicada para ver los CVs recibidos",
      noCvsAvailable: "No hay CV manual disponible",
      noCvsReceived: "No se recibió CV para esta oferta"
    },
    
    cvLabels: {
      published: "Publicada",
      manual: "Manual",
      application: "Candidatura",
      textExtracted: "Texto extraído",
      textRequired: "Texto requerido",
      alreadyAnalyzed: "Ya analizado"
    },
    
    analysisInfo: {
      limitTitle: "Límite de análisis IA",
      limitDescription: "Puedes analizar un máximo de 25 CVs a la vez para garantizar un análisis de calidad óptima. Para analizar otros CVs de la misma oferta, realiza múltiples análisis sucesivos.",
      startTitle: "Iniciar análisis IA",
      startDescription: "Analizar {{count}}/25 CV(s) para la oferta \"{{title}}\"",
      startDescriptionEmpty: "Selecciona una oferta y CVs para comenzar"
    },
    
    actions: {
      export: "Exportar (CSV)",
      analyzing: "Análisis en progreso...",
      startAnalysisButton: "Iniciar análisis"
    },
    
    results: {
      title: "Resultados del análisis (Clasificados por puntuación)",
      viewDetails: "Ver detalles",
      detailModalTitle: "Análisis detallado - {{name}}",
      globalScore: "Puntuación global",
      recommendation: "Recomendación",
      rank: "Rango: #{{rank}}",
      detailedAnalysis: "Análisis detallado",
      strengths: "Puntos fuertes",
      weaknesses: "Áreas de mejora",
      close: "Cerrar"
    }
  },

  // Results Page
  results: {
    title: "Resultados de Análisis",
    
    errors: {
      dataLoadFailed: "Error al cargar los datos",
      resultsLoadFailed: "Error al cargar los resultados",
      deleteFailed: "Error durante la eliminación",
      exportFailed: "Error durante la exportación"
    },
    
    messages: {
      noResults: "No se encontraron resultados de análisis",
      deleteSuccess: "Resultado eliminado con éxito",
      exportSuccess: "Resultados exportados con éxito",
      exportAllNotAvailable: "Exportación para todas las ofertas no disponible en este momento"
    },
    
    labels: {
      cvs: "CVs",
      topScore: "Puntuación Máxima",
      recommended: "Recomendados",
      unknownCandidate: "Candidato desconocido",
      deletedCv: "CV eliminado",
      score: "Puntuación",
      team: "Equipo",
      offer: "Oferta"
    },
    
    subtitle: {
      adminWithResults: "{{count}} análisis para {{offerCount}} oferta(s)",
      adminNoOffers: "Análisis IA de tu equipo",
      hrWithResults: "{{count}} resultados de análisis",
      hrNoResults: "Resultados de análisis compartidos con tu equipo"
    },
    
    stats: {
      total: "Total Analizados",
      recommended: "Recomendados",
      consider: "A Considerar",
      avgScore: "Puntuación Media"
    },
    
    filters: {
      offer: "Oferta de trabajo",
      allOffers: "Todas las ofertas",
      search: "Buscar",
      searchPlaceholder: "Nombre del CV...",
      score: "Puntuación",
      allScores: "Todas las puntuaciones",
      excellent: "80-100 (Excelente)",
      good: "60-79 (Bueno)",
      average: "40-59 (Promedio)",
      weak: "0-39 (Débil)",
      recommendation: "Recomendación",
      allRecommendations: "Todas",
      recommended: "Recomendado",
      consider: "A considerar",
      notRecommended: "No recomendado",
      sortBy: "Ordenar por",
      scoreDesc: "Puntuación descendente",
      scoreAsc: "Puntuación ascendente",
      newest: "Más reciente",
      oldest: "Más antiguo"
    },
    
    viewModes: {
      byOffer: "Por Oferta",
      list: "Lista"
    },
    
    loading: {
      offers: "Cargando ofertas...",
      results: "Cargando resultados de análisis..."
    },
    
    emptyStates: {
      noOffers: {
        title: "No hay ofertas de trabajo",
        description: "Primero debes crear ofertas de trabajo antes de poder analizar CVs."
      },
      noFilterResults: {
        title: "Ningún resultado coincide con los filtros",
        description: "Intenta modificar tus filtros de búsqueda o selecciona otra oferta."
      },
      noAnalysis: {
        title: "No hay análisis disponible",
        descriptionAll: "Aún no se ha realizado ningún análisis. Comienza analizando CVs contra tus ofertas.",
        descriptionSpecific: "No se ha realizado ningún análisis para esta oferta específica."
      }
    },
    
    actions: {
      refresh: "Actualizar",
      export: "Exportar (CSV)",
      exportTitle: "Exportar resultados",
      exportNotAvailable: "Exportación no disponible para todas las ofertas",
      createOffer: "Crear oferta",
      analyzeCvs: "Analizar CVs",
      viewAllAnalyses: "Ver todos los análisis",
      viewDetails: "Ver detalles",
      delete: "Eliminar"
    },
    
    deleteModal: {
      title: "Eliminar resultado",
      message: "¿Estás seguro de que quieres eliminar este resultado de análisis? Esta acción es irreversible.",
      confirm: "Eliminar",
      cancel: "Cancelar"
    },
    
    detailModal: {
      title: "Análisis detallado - {{filename}}",
      globalScore: "Puntuación global",
      recommendation: "Recomendación",
      analyzedOn: "Analizado el {{date}}",
      analysisDate: "Fecha de análisis",
      detailedAnalysis: "Análisis detallado",
      strengths: "Puntos fuertes",
      weaknesses: "Áreas de mejora",
      skillsEvaluation: "Evaluación de habilidades",
      skillsRadarTitle: "Análisis comparativo de habilidades",
      close: "Cerrar"
    },
    
    radar: {
      score: "Puntuación",
      required: "Requerido",
      noData: "No hay datos disponibles",
      candidateScore: "Puntuación del candidato",
      jobRequirements: "Requisitos del puesto",
      weak: "Débil",
      medium: "Medio",
      strong: "Fuerte"
    }
  },

  // Settings Page
  settings: {
    title: "Configuración",
    subtitle: "Gestiona tu perfil, preferencias y cuenta",
    
    tabs: {
      account: "Cuenta",
      profile: "Perfil",
      password: "Contraseña",
      preferences: "Preferencias",
      company: "Empresa",
      billing: "Pago y facturación",
      notifications: "Notificaciones",
      developer: "Desarrollador",
      usage: "Uso",
      cleanup: "Limpieza automática"
    },
    
    errors: {
      dataLoadFailed: "Error al cargar los datos",
      fillAllFields: "Por favor complete todos los campos",
      saveError: "Error durante el guardado"
    },
    
    actions: {
      save: "Guardar",
      saving: "Guardando...",
      test: "Probar",
      testing: "Probando...",
      delete: "Eliminar",
      cancel: "Cancelar",
      refresh: "Actualizar"
    },
    
    accountInfo: {
      title: "Información de la cuenta",
      registeredOn: "Registrado el {{date}}",
      verified: "Cuenta verificada",
      unverified: "No verificado",
      roles: {
        admin: "Administrador",
        rh: "RRHH"
      }
    },
    
    profile: {
      title: "Información del perfil",
      fullName: "Nombre completo",
      fullNamePlaceholder: "Tu nombre completo",
      email: "Dirección de correo",
      emailPlaceholder: "tu@correo.com",
      emailChangeNote: "Cambiar el correo requerirá nueva verificación",
      updateSuccess: "Perfil actualizado con éxito",
      updateError: "Error actualizando el perfil",
      loadError: "Error al cargar el perfil",
      sync: {
        success: "Estadísticas sincronizadas",
        error: "Error al sincronizar"
      },
      counters: {
        initSuccess: "Contadores inicializados",
        initError: "Error al inicializar los contadores"
      },
      usage: {
        dataUnavailable: "Datos de uso no disponibles",
        limitReached: "Límite alcanzado ({{used}}/{{limit}})",
        offers: "Ofertas de empleo",
        cvUploads: "CVs cargados",
        analyses: "Análisis IA",
        aiResume: "Resumen IA CV",
        aiResumeDesc: "Creación de fichas de candidatos via IA",
        rhUsers: "Usuarios RRHH"
      }
    },
    
    password: {
      title: "Cambiar contraseña",
      current: "Contraseña actual",
      currentPlaceholder: "Tu contraseña actual",
      new: "Nueva contraseña",
      newPlaceholder: "Tu nueva contraseña",
      confirm: "Confirmar nueva contraseña",
      confirmPlaceholder: "Confirma tu nueva contraseña",
      minLengthNote: "Mínimo 8 caracteres",
      mismatch: "Las nuevas contraseñas no coinciden",
      minLength: "La nueva contraseña debe contener al menos 8 caracteres",
      updateSuccess: "Contraseña cambiada con éxito",
      updateError: "Error cambiando la contraseña",
      changeButton: "Cambiar contraseña",
      changing: "Cambiando..."
    },
    
    preferences: {
      title: "Preferencias",
      language: "Idioma de la interfaz",
      cleanupDelay: "Retraso de limpieza automática",
      cleanupDelayNote: "Los archivos se eliminarán automáticamente después de este período",
      emailNotifications: "Notificaciones por correo",
      emailNotificationsNote: "Recibir notificaciones para análisis completados",
      updateSuccess: "Preferencias actualizadas con éxito",
      updateError: "Error actualizando preferencias",
      
      // Automatic Cleanup Settings
      automaticCleanup: {
        title: "Limpieza automática de documentos",
        subtitle: "Configure la limpieza automática para optimizar su espacio de almacenamiento",
        enable: "Activar limpieza automática",
        schedule: "Programación",
        scheduleType: {
          label: "Tipo de programación",
          daily: "Diario",
          weekly: "Semanal",
          monthly: "Mensual",
          custom: "Fecha personalizada"
        },
        frequency: {
          label: "Frecuencia",
          everyDay: "Todos los días",
          everyXDays: "Cada {{count}} días"
        },
        timezone: {
          label: "Zona horaria",
          description: "La limpieza se ejecutará según esta zona horaria"
        },
        dayOfWeek: {
          label: "Día de la semana",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sábado",
          sunday: "Domingo"
        },
        dayOfMonth: {
          label: "Día del mes",
          day: "Día {{day}}"
        },
        time: {
          label: "Hora de ejecución",
          format: "HH:MM (24h)"
        },
        customDate: {
          label: "Fecha y hora",
          placeholder: "Seleccionar una fecha"
        },
        recurring: {
          label: "Ejecución recurrente",
          yes: "Sí, repetir según la programación",
          no: "No, ejecutar solo una vez"
        },
        cleanupOptions: {
          title: "Opciones de limpieza",
          daysOld: {
            label: "Eliminar archivos más antiguos que",
            suffix: "días"
          },
          fileTypes: {
            label: "Tipos de archivos a limpiar",
            cvs: "CVs cargados",
            results: "Resultados de análisis",
            tempFiles: "Archivos temporales"
          },
          excludeStarred: "Excluir elementos marcados",
          excludeStarredNote: "Los archivos marcados con una estrella se conservarán"
        },
        actions: {
          save: "Guardar configuración",
          saving: "Guardando...",
          runNow: "Ejecutar ahora",
          runNowDescription: "Ejecutar una limpieza manual inmediata con la configuración actual",
          running: "Limpieza en progreso...",
          cancel: "Cancelar"
        },
        jobHistory: {
          title: "Historial de limpiezas",
          noHistory: "No hay historial disponible",
          columns: {
            filesDeleted: "Archivos eliminados",
            spaceFreed: "Espacio liberado"
          },
          status: {
            pending: "Pendiente",
            processing: "En proceso",
            completed: "Completado",
            failed: "Fallido",
            retry: "Reintentando"
          },
          details: {
            manual: "Manual",
            scheduled: "Programado",
            filesDeleted: "{{count}} archivo(s) eliminado(s)",
            spaceFreed: "{{size}} liberado(s)",
            duration: "Duración: {{time}}",
            error: "Error: {{message}}"
          }
        },
        success: {
          saved: "Configuración de limpieza guardada",
          started: "Limpieza iniciada con éxito"
        },
        confirmRunNow: "¿Está seguro de que desea ejecutar una limpieza manual ahora?",
        error: {
          save: "Error al guardar la configuración",
          start: "Error al iniciar la limpieza",
          load: "Error al cargar la configuración"
        }
      }
    },
    
    company: {
      title: "Configuración de empresa",
      subtitle: "Configura la información de tu empresa que aparecerá en las páginas públicas de ofertas de trabajo.",
      name: "Nombre de la empresa",
      namePlaceholder: "Nombre de tu empresa",
      nameNote: "Este nombre aparecerá en las páginas públicas de ofertas de trabajo",
      industry: "Sector de actividad",
      industryPlaceholder: "Tecnología, Salud, Finanzas...",
      selectIndustry: "Selecciona un sector",
      logo: {
        title: "Logo de la empresa",
        current: "Logo actual:",
        change: "Cambiar logo",
        upload: "Subir logo",
        formats: "PNG, JPG, GIF, WebP hasta 5MB",
        note: "El logo aparecerá en el encabezado de las páginas públicas de ofertas de trabajo. Recomendado: formato cuadrado o rectángulo horizontal, fondo transparente.",
        newSelected: "✓ Nuevo archivo seleccionado: {{name}}",
        remove: "Eliminar",
        invalidFormat: "Formato de archivo no soportado. Usa JPG, PNG, GIF o WebP.",
        tooLarge: "El archivo es demasiado grande. Tamaño máximo: 5MB.",
        alt: "Logo de empresa"
      },
      preview: {
        title: "Vista previa en páginas públicas:",
        placeholder: "Nombre de la empresa"
      },
      updateSuccess: "Configuración de empresa actualizada con éxito",
      updateError: "Error actualizando configuración de empresa"
    },
    
    notifications: {
      mainTitle: "Notificaciones",
      mainSubtitle: "Configura quién debe ser notificado por correo para diferentes eventos de la plataforma.",
      updateSuccess: "Configuración de notificaciones actualizada con éxito",
      updateError: "Error actualizando notificaciones",
      applications: {
        title: "Notificaciones de candidaturas",
        description: "Recibir notificaciones cuando se envían nuevas candidaturas en tus ofertas publicadas.",
        enabled: "Activar notificaciones de candidaturas",
        notifyPublisher: "Notificar al creador de la oferta",
        notifyPublisherNote: "El creador de cada oferta recibirá las notificaciones",
        customUsers: "Usuarios adicionales a notificar",
        customUsersNote: "Estos usuarios recibirán todas las notificaciones de candidaturas"
      },
      appointments: {
        title: "Notificaciones de citas",
        description: "Recibir notificaciones cuando los candidatos reservan franjas horarias.",
        enabled: "Activar notificaciones de citas",
        notifyRecruiter: "Notificar al reclutador concernido",
        notifyRecruiterNote: "El reclutador recibirá notificaciones para sus citas",
        customUsers: "Usuarios adicionales a notificar",
        customUsersNote: "Estos usuarios recibirán todas las notificaciones de citas"
      },
      analyses: {
        title: "Notificaciones de análisis completados",
        description: "Recibir notificaciones cuando se completa un análisis de CVs.",
        enabled: "Activar notificaciones de análisis",
        notifyExecutor: "Notificar al ejecutor del análisis",
        notifyExecutorNote: "El usuario que lanza el análisis recibirá la notificación",
        customUsers: "Usuarios adicionales a notificar",
        customUsersNote: "Estos usuarios recibirán todas las notificaciones de análisis"
      },
      noHrUsers: "No hay usuarios de RRHH disponibles",
      summary: {
        title: "Resumen de configuración",
        publisherNotified: "El creador de cada oferta será notificado",
        recruiterNotified: "El reclutador concernido será notificado",
        executorNotified: "El ejecutor será notificado",
        customUsersNotified: "{{count}} usuario(s) adicional(es)",
        allDisabled: "⚠️ Todas las notificaciones están desactivadas"
      },
      // Legacy fields for backward compatibility
      title: "Notificaciones de candidaturas",
      subtitle: "Configura quién debe ser notificado por correo al recibir nuevas candidaturas vía ofertas publicadas.",
      enabled: "Notificaciones por correo activadas",
      enabledNote: "Activar/desactivar todas las notificaciones de candidaturas",
      defaultConfig: "Configuración por defecto",
      notifyPublisher: "Notificar al creador de la oferta",
      notifyPublisherNote: "Por defecto, quien publica una oferta recibe notificaciones para esa oferta",
      customUsers: "Usuarios adicionales a notificar",
      customUsersNote: "Selecciona usuarios de RRHH que deben recibir notificaciones para todas las candidaturas"
    },
    
    usage: {
      title: "Uso y límites",
      currentPlan: "Plan actual",
      refresh: "Actualizar datos",
      expiresOn: "Expira el {{date}}",
      notDefined: "No definido",
      infiniteLimit: "∞",
      tips: {
        title: "Consejos de uso",
        resetMonthly: "• Los límites se reinician cada mes",
        deleteOldCvs: "• Elimina CVs antiguos para liberar espacio",
        autoCleanup: "• Usa la limpieza automática para optimizar el almacenamiento",
        contactSupport: "• Contacta soporte para aumentar tus límites"
      }
    },
    
    minio: {
      title: "Almacenamiento MinIO Personalizado",
      subtitle: "Configura tu propio servidor MinIO para control completo de tus datos",
      warning: {
        title: "⚠️ Advertencia Importante",
        technical: "• Esta funcionalidad está reservada para administradores técnicos",
        ownership: "• Eres responsable de tu infraestructura MinIO y su seguridad",
        costs: "• Alojar MinIO puede generar costos adicionales (servidor, almacenamiento, copias)",
        misconfiguration: "• Una configuración incorrecta puede hacer tus archivos inaccesibles"
      },
      status: {
        title: "Estado actual",
        hasConfig: "Configuración guardada",
        noConfig: "Sin configuración",
        enabled: "Almacenamiento activo",
        disabled: "Almacenamiento Candio por defecto",
        migration: "Migración: {{status}}"
      },
      config: {
        title: "Configuración MinIO",
        endpoint: "Endpoint",
        endpointPlaceholder: "minio.tu-dominio.com",
        port: "Puerto",
        useSSL: "Usar SSL",
        accessKey: "Access key",
        secretKey: "Secret key",
        publicUrl: "URL pública (opcional)",
        defaultBucket: "Bucket por defecto",
        systemBucket: "Bucket del sistema",
        testConnection: "Probar conexión",
        configure: "Configurar almacenamiento MinIO",
        save: "Guardar",
        configSaved: "Configuración guardada",
        configuredOn: "Configurado el",
        dateUnknown: "Fecha desconocida",
        enable: "Activar",
        disable: "Desactivar",
        delete: "Eliminar"
      },
      errors: {
        fillAllFields: "Completa todos los campos obligatorios"
      },
      testSuccess: "¡Configuración MinIO válida! ✅",
      testFailed: "Configuración MinIO inválida",
      testError: "Error probando configuración",
      saveSuccess: "¡Configuración MinIO guardada con éxito! 🎉",
      saveError: "Error guardando configuración",
      enabled: "¡Configuración MinIO activada!",
      disabled: "¡Configuración MinIO desactivada!",
      toggleError: "Error cambiando estado",
      deleteConfirm: "¿Estás seguro de que quieres eliminar tu configuración MinIO personalizada?",
      deleteSuccess: "¡Configuración MinIO eliminada!",
      deleteError: "Error durante eliminación",
      migration: {
        inProgress: "Migración en curso",
        status: "Estado:",
        files: "archivos",
        none: "ninguna",
        title: "Migración de datos",
        description: "Puedes migrar tus datos existentes entre el almacenamiento Candio por defecto y tu almacenamiento MinIO personalizado.",
        estimate: "Estimar migración",
        toCustom: "Migrar a mi almacenamiento",
        fromCustom: "Volver al almacenamiento Candio",
        toCustomConfirm: "¿Estás seguro de que quieres migrar tus datos a tu almacenamiento MinIO personalizado? Esta operación puede tomar tiempo.",
        fromCustomConfirm: "¿Estás seguro de que quieres migrar tus datos al almacenamiento Candio por defecto? Esta operación puede tomar tiempo.",
        toCustomStarted: "¡Migración iniciada en segundo plano! 🚀",
        fromCustomStarted: "¡Migración de retorno iniciada en segundo plano! 🔄",
        startError: "Error iniciando migración",
        estimateError: "Error durante estimación",
        estimateTitle: "Estimación de migración",
        totalFiles: "Archivos a migrar",
        totalSize: "Tamaño total",
        duration: "Duración estimada: {{duration}}"
      }
    },

    aiProviders: {
      title: "Proveedores IA",
      subtitle: "Configura tus claves API para habilitar resúmenes y análisis IA",
      openai: {
        title: "OpenAI",
        description: "Clave API para resúmenes y análisis IA."
      },
      anthropic: {
        title: "Anthropic",
        description: "Clave API para análisis avanzados con Claude."
      },
      apiKey: "Clave API",
      apiKeyPlaceholder: "sk-...",
      save: "Guardar",
      delete: "Eliminar",
      confirmTitle: "Eliminar clave API",
      updatedAt: "Actualizado el {{date}}",
      tokenPreview: "Clave guardada: {{token}}",
      loading: "Cargando...",
      note: "Si no se define ninguna clave, el sistema usará las claves globales de Candio.",
      confirmDelete: "¿Eliminar esta clave API?",
      messages: {
        saved: "Clave API guardada",
        deleted: "Clave API eliminada"
      },
      errors: {
        required: "Introduce una clave API válida",
        saveFailed: "Error al guardar la clave API",
        deleteFailed: "Error al eliminar la clave API"
      }
    },
    
    jobs: {
      title: "Trabajos en segundo plano",
      noJobs: "Sin trabajos ejecutándose",
      refresh: "Actualizar",
      loading: "Cargando...",
      progress: "Progreso",
      created: "Creado el {{date}} a las {{time}}",
      attempts: "Intento {{current}}/{{max}}",
      error: "Error:",
      storageMigration: "Migración almacenamiento",
      storageCleanup: "Limpieza almacenamiento",
      fileTransfer: "Transferencia de Archivos",
      unknown: "Tipo desconocido"
    },
    
    developer: {
      title: "Configuración de Desarrollador",
      techInfo: {
        title: "Información técnica",
        containers: "• Tus archivos se almacenan en buckets MinIO privados dedicados al workspace",
        structure: "• La estructura de carpetas sigue el formato: cvs/, logos/, photos/",
        security: "• El acceso está asegurado por URLs firmadas temporales",
        migration: "• La migración puede tomar tiempo dependiendo del volumen de datos",
        background: "• Las migraciones se ejecutan en segundo plano para evitar bloquear la aplicación"
      }
    },
    
    cleanup: {
      title: "Limpieza automática",
      subtitle: "Configure la limpieza automática de archivos y datos obsoletos"
    },
    
    billing: {
      title: "Pago y facturación",
      subtitle: "Administra tus métodos de pago y consulta tus facturas.",
      error: {
        load: "Error al cargar los datos de facturación",
        portalUrl: "No se puede acceder al portal de facturación"
      },
      
      paymentMethods: {
        title: "Métodos de pago",
        subtitle: "Administra tus tarjetas de crédito y métodos de pago",
        manage: "Administrar",
        expires: "Expira",
        default: "Predeterminado",
        noMethods: "No hay métodos de pago registrados",
        addMethod: "Agregar método de pago"
      },
      
      invoices: {
        title: "Facturas",
        subtitle: "Historial de tus facturas y pagos",
        date: "Fecha",
        plan: "Plan",
        amount: "Monto",
        statusColumn: "Estado",
        status: {
          paid: "Pagada",
          pending: "Pendiente",
          failed: "Fallida"
        },
        actions: "Acciones",
        download: "Descargar",
        downloadSuccess: "Factura descargada exitosamente",
        downloadError: "Error al descargar la factura",
        noInvoices: "No hay facturas disponibles",
        subscription: "Suscripción"
      }
    }
  },

  // HR Management Page (Gestión RRHH)
  rh: {
    title: "Gestión RRHH",
    subtitle: "Gestiona las cuentas de usuarios RRHH de tu equipo",
    noUsers: "No se encontraron usuarios",
    createFirst: "Comienza agregando un usuario RRHH",
    searchPlaceholder: "Buscar un usuario...",
    addUser: "Agregar Usuario RRHH",
    
    // Dashboard stats
    stats: {
      hrUsers: "Usuarios RRHH",
      totalAnalyses: "Análisis Totales", 
      createdOffers: "Ofertas Creadas",
      uploadedCvs: "CVs Subidos",
      activeAccounts: "Cuentas Activadas",
      inactiveAccounts: "Cuentas No Activadas"
    },
    
    // License information
    license: {
      title: "Información de Licencia",
      currentPackage: "Paquete Actual",
      status: "Estado",
      expiration: "Vencimiento",
      active: "Activa",
      inactive: "Inactiva",
      notDefined: "No definido",
      notDefinedDate: "No definida"
    },
    
    // Filters
    filters: {
      allStatuses: "Todos los estados",
      verified: "Verificados",
      unverified: "No verificados"
    },
    
    // Table headers
    table: {
      user: "Usuario",
      email: "Correo",
      status: "Estado",
      createdDate: "Fecha de Creación",
      actions: "Acciones"
    },
    
    // User status
    userStatus: {
      verified: "Verificado",
      unverified: "No verificado",
      hrUser: "Usuario RRHH",
      nameNotDefined: "Nombre no definido"
    },
    
    // Pagination
    pagination: {
      previous: "Anterior",
      next: "Siguiente",
      showing: "Mostrando",
      to: "a",
      of: "de",
      results: "resultados"
    },
    
    // Search and filters help text
    searchHelp: {
      modifySearch: "Intenta modificar tus criterios de búsqueda"
    },
    
    // Modals
    modals: {
      add: {
        title: "Agregar Usuario RRHH",
        fullName: "Nombre Completo",
        emailAddress: "Dirección de Correo",
        password: "Contraseña",
        namePlaceholder: "Nombre del usuario",
        emailPlaceholder: "correo@ejemplo.com",
        passwordPlaceholder: "Contraseña (mín. 8 caracteres)",
        verificationNote: "Se enviará un correo de verificación al usuario",
        cancel: "Cancelar",
        create: "Crear Usuario",
        creating: "Creando..."
      },
      edit: {
        title: "Editar Usuario",
        fullName: "Nombre Completo",
        emailAddress: "Dirección de Correo",
        newPassword: "Nueva Contraseña (opcional)",
        emailNote: "Cambiar el correo reiniciará la verificación",
        passwordPlaceholder: "Dejar vacío para no modificar",
        cancel: "Cancelar",
        update: "Actualizar",
        updating: "Actualizando..."
      },
      delete: {
        title: "Eliminar Usuario",
        confirmText: "¿Estás seguro de que quieres eliminar al usuario",
        warningText: "Esta acción es irreversible. El usuario ya no podrá acceder a su cuenta.",
        cancel: "Cancelar",
        delete: "Eliminar",
        deleting: "Eliminando..."
      }
    },
    
    // Action tooltips
    tooltips: {
      resendVerification: "Reenviar correo de verificación",
      edit: "Editar",
      delete: "Eliminar"
    },
    
    // Toast messages
    messages: {
      loadError: "Error al cargar los datos",
      fillAllFields: "Por favor complete todos los campos",
      fillNameEmail: "Por favor complete nombre y correo",
      passwordMinLength: "La contraseña debe tener al menos 8 caracteres",
      userCreated: "Usuario RRHH creado con éxito",
      createError: "Error al crear el usuario",
      userUpdated: "Usuario actualizado con éxito",
      updateError: "Error al actualizar el usuario",
      userDeleted: "Usuario eliminado con éxito",
      deleteError: "Error al eliminar el usuario",
      alreadyVerified: "El usuario ya está verificado",
      verificationSent: "Correo de verificación enviado a",
      emailError: "Error al enviar el correo"
    }
  },

  // Appointment System
  appointments: {
    title: "Programación de citas",
    subtitle: "Gestiona tus citas y configura tu disponibilidad",
    
    // Navigation tabs
    tabs: {
      calendar: "Mi calendario",
      calendarDesc: "Visualiza y gestiona tus citas",
      availability: "Disponibilidad",
      availabilityDesc: "Configura tus horarios disponibles",
      settings: "Configuración",
      settingsDesc: "Duración de citas, plazos, URL de reserva",
      templates: "Plantillas de correo",
      templatesDesc: "Personaliza tus correos de citas",
      holidays: "Días festivos",
      holidaysDesc: "Gestiona tus días de descanso",
      video: "Videoconferencia",
      videoDesc: "Configura tus herramientas de reunión"
    },
    
    // Status
    status: {
      pending: "Pendiente",
      confirmed: "Confirmada",
      cancelled: "Cancelada"
    },
    
    // Filters
    filters: {
      upcoming: "Próximas",
      confirmed: "Confirmadas",
      cancelled: "Canceladas"
    },
    
    // Calendar component
    calendar: {
      today: "Hoy",
      viewDay: "Día",
      viewWeek: "Semana",
      viewMonth: "Mes",
      previous: "Anterior",
      next: "Siguiente",
      scopeMy: "Mi calendario",
      scopeTeam: "Calendario del equipo",
      filterRecruiter: "Filtrar",
      filterAll: "Todos los reclutadores",
      recruiter: "Reclutador",
      densityComfortable: "Confort",
      densityCompact: "Compacto",
      appointmentDetails: "Detalles de la cita",
      candidate: "Candidato",
      online: "En línea",
      physical: "Presencial",
      joinMeeting: "Unirse a la reunión",
      cancellationReason: "Motivo de cancelación",
      confirm: "Confirmar",
      cancel: "Cancelar",
      cancelReason: "Motivo de cancelación (opcional):",
      bookingUrl: "Tu enlace de reserva",
      dayView: "Citas del",
      appointment: "cita",
      appointments: "citas",
      inPerson: "Presencial",
      noAppointments: "No hay citas para esta fecha",
      error: {
        fetch: "Error al cargar las citas",
        confirm: "Error al confirmar la cita",
        cancel: "Error al cancelar la cita",
        forbidden: "No tienes acceso a estas citas",
        noVideoAdmin: "Por favor, configura tu herramienta de reunión en Configuración > Integración de reuniones.",
        noVideoUser: "Por favor, contacta a tu administrador para habilitar la integración de herramientas de videoconferencia.",
        urlRequired: "Por favor, proporciona la URL de la reunión"
      },
      manualUrlRequired: "Por favor, proporciona la URL de la reunión",
      urlHint: "Esta URL se enviará al candidato en el correo de confirmación",
      success: {
        confirm: "Cita confirmada con éxito",
        cancel: "Cita cancelada",
        copyUrl: "Enlace copiado al portapapeles"
      },
      modalTip: "Haz clic en una cita o en el ícono del ojo para acceder a la gestión detallada de la reserva"
    },
    
    // Recent invitations
    recentInvitations: {
      title: "Invitaciones de citas recientes",
      refreshed: "Lista actualizada",
      empty: "No hay invitaciones enviadas recientemente",
      sentOn: "Enviado el",
      error: {
        fetch: "Error al cargar las invitaciones"
      }
    },
    
    // Availability settings
    availability: {
      title: "Mi disponibilidad",
      description: "Configura tus franjas horarias disponibles para cada día de la semana",
      days: {
        monday: "Lunes",
        tuesday: "Martes",
        wednesday: "Miércoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "Sábado",
        sunday: "Domingo"
      },
      add: "Añadir disponibilidad",
      noneForDay: "Sin disponibilidad",
      confirmDelete: "¿Estás seguro de que quieres eliminar esta disponibilidad?",
      confirmDeleteTitle: "Eliminar Disponibilidad",
      addSlot: "Añadir franja",
      noSlots: "Sin franjas configuradas",
      error: {
        fetch: "Error al cargar disponibilidad",
        add: "Error al añadir franja",
        delete: "Error al eliminar franja",
        toggle: "Error al actualizar franja"
      },
      success: {
        add: "Disponibilidad añadida con éxito",
        delete: "Disponibilidad eliminada con éxito",
        toggle: "Franja actualizada"
      },
      confirm: {
        delete: "¿Estás seguro de que quieres eliminar esta franja?"
      }
    },
    
    // Booking settings
    settings: {
      title: "Configuración de reservas",
      description: "Configura las reglas de reserva de citas",
      systemStatus: "Sistema de reservas",
      statusDescription: "Activar o desactivar las reservas en línea",
      statusActive: "Los candidatos pueden reservar citas",
      statusInactive: "Las reservas están temporalmente desactivadas",
      configTitle: "Configuración de franjas",
      configDescription: "Define la duración y las reglas de planificación",
      duration: "Duración de las citas",
      durationHelp: "Duración estándar para cada cita",
      bufferTime: "Tiempo de descanso entre citas",
      bufferHelp: "Pausa automática entre cada cita",
      noBreak: "Sin descanso",
      minAdvance: "Reserva mínima con antelación",
      minAdvanceHelp: "Tiempo mínimo de aviso antes de una cita",
      maxAdvance: "Reserva máxima con antelación",
      maxAdvanceHelp: "Horizonte máximo de planificación",
      timezone: "Zona horaria",
      timezoneInfo: "Todas tus franjas se mostrarán en esta zona horaria",
      useDetected: "Usar tu zona horaria detectada",
      autoSaving: "Guardado automático...",
      active: "Activar reserva de citas en línea",
      urlTitle: "URL de reserva",
      urlDescription: "Personaliza tu enlace de reserva de citas",
      customUrl: "URL personalizada",
      generateUrl: "Generar URL aleatoria",
      checkingAvailability: "Verificando disponibilidad...",
      urlTaken: "Esta URL ya está en uso",
      urlAvailable: "Esta URL está disponible",
      yourUrl: "Tu enlace de reserva",
      shareUrl: "Comparte este enlace con tus candidatos para permitirles reservar citas",
      preview: "Vista previa",
      error: {
        fetch: "Error al cargar configuración",
        save: "Error al guardar configuración",
        generateSlug: "Error al generar slug"
      },
      success: {
        save: "Configuración guardada con éxito",
        copy: "Enlace copiado al portapapeles"
      }
    },
    
    // Video Configuration Alert
    videoConfigAlert: {
      title: "Configuración de video requerida",
      message: "Para habilitar citas en línea, configura un servicio de videoconferencia.",
      configure: "Configurar ahora"
    },
    
    // Email templates
    templates: {
      title: "Plantillas de correo",
      description: "Personaliza los correos automatizados",
      types: {
        invitation: "Invitación a cita",
        invitationDesc: "Correo enviado a candidatos para invitarlos a reservar una franja",
        confirmation: "Confirmación de cita",
        confirmationDesc: "Correo enviado automáticamente tras confirmar la cita",
        cancellation: "Cancelación de cita",
        cancellationDesc: "Correo enviado cuando se cancela la cita"
      },
      availableVars: "Variables disponibles",
      subject: "Asunto",
      body: "Cuerpo del mensaje",
      reset: "Restablecer",
      preview: "Vista previa",
      previewTitle: "Vista previa del correo",
      previewNote: "Esta es una vista previa con datos de ejemplo",
      error: {
        fetch: "Error al cargar plantillas",
        save: "Error al guardar plantilla",
        reset: "Error al restablecer plantilla",
        preview: "Error al previsualizar plantilla"
      },
      success: {
        save: "Plantilla guardada con éxito",
        reset: "Plantilla restablecida"
      },
      confirm: {
        reset: "¿Estás seguro de que quieres restablecer esta plantilla?"
      }
    },
    
    // System email templates (for AdminLanguageContext)
    systemEmailTemplates: {
      invitation: {
        title: "Invitación a entrevista",
        greeting: "Hola {{candidate_name}},",
        intro: "Gracias por tu candidatura y nos gustaría conocerte para discutir tu perfil.",
        interviewDetails: "Detalles de la entrevista",
        recruiter: "Reclutador",
        position: "Puesto",
        company: "Empresa",
        duration: "Duración",
        type: "Tipo",
        schedulingInfo: "Para programar tu entrevista, haz clic en el enlace a continuación y elige un horario que te convenga:",
        bookingButton: "Elegir un horario",
        importantInfo: "Información importante:",
        confirmationNote: "Recibirás una confirmación por correo electrónico después de elegir tu horario",
        onlineNote: "El enlace de videoconferencia se te enviará en el correo de confirmación",
        physicalNote: "La dirección exacta se te comunicará en el correo de confirmación",
        regards: "Saludos cordiales,",
        team: "El equipo {{company_name}}"
      },
      confirmation: {
        title: "Confirmación de cita",
        greeting: "Hola {{candidate_name}},",
        confirmed: "¡Tu cita ha sido confirmada!",
        details: "Detalles de la cita",
        date: "Fecha",
        time: "Hora",
        duration: "Duración",
        type: "Tipo",
        recruiter: "Reclutador",
        onlineInstructions: "Tu cita tendrá lugar en línea. Únete a la reunión haciendo clic en el enlace a continuación:",
        joinButton: "Unirse a la reunión",
        physicalInstructions: "Tu cita tendrá lugar en la siguiente dirección:",
        preparation: "Preparación",
        prepTips: "Siéntete libre de preparar tus preguntas y revisar tu CV.",
        reschedule: "Si necesitas reprogramar esta cita, por favor contáctanos lo antes posible.",
        regards: "Saludos cordiales,",
        team: "El equipo {{company_name}}"
      },
      cancellation: {
        title: "Cancelación de cita",
        greeting: "Hola {{candidate_name}},",
        cancelled: "Tu cita ha sido cancelada",
        reason: "Razón",
        noReason: "No se proporcionó una razón específica",
        reschedule: "Si deseas reprogramar una entrevista, no dudes en contactarnos.",
        contact: "Puedes contactarnos en la siguiente dirección:",
        apologies: "Nos disculpamos por cualquier inconveniente causado.",
        regards: "Saludos cordiales,",
        team: "El equipo {{company_name}}"
      },
      reminder: {
        title: "Recordatorio de cita",
        greeting: "Hola {{candidate_name}},",
        reminder: "Te recordamos que tienes una cita programada",
        when: "{{relative_time}}",
        details: "Detalles de la cita",
        preparation: "Preparación sugerida",
        prepTips: "Revisa tu CV y prepara tus preguntas sobre el puesto y la empresa.",
        onlineReminder: "El enlace de videoconferencia está disponible a continuación:",
        joinButton: "Unirse a la reunión",
        physicalReminder: "Dirección de la reunión:",
        regards: "Saludos cordiales,",
        team: "El equipo {{company_name}}"
      },
      recruiterNotification: {
        title: "Nueva cita reservada",
        greeting: "Hola {{recruiter_name}},",
        newBooking: "Se ha reservado una nueva cita",
        candidateInfo: "Información del candidato",
        name: "Nombre",
        email: "Correo electrónico",
        phone: "Teléfono",
        subject: "Asunto",
        appointmentDetails: "Detalles de la cita",
        date: "Fecha",
        time: "Hora",
        duration: "Duración",
        type: "Tipo",
        action: "Acción requerida",
        confirmReminder: "No olvides confirmar esta cita desde tu calendario para que el candidato reciba el enlace de videoconferencia.",
        dashboardButton: "Acceder al panel",
        regards: "Saludos cordiales,",
        system: "El sistema Candio"
      }
    },
    
    // Public booking page (for AdminLanguageContext)
    publicBooking: {
      title: "Reservar cita con",
      selectDate: "Selecciona una fecha",
      selectTime: "Elige un horario",
      noSlots: "No hay horarios disponibles",
      selectOtherDate: "Por favor, selecciona otra fecha",
      meetingType: "Tipo de reunión",
      online: "En línea",
      onlineDesc: "Videoconferencia",
      physical: "Presencial",
      physicalDesc: "Reunión cara a cara",
      yourInfo: "Tu información",
      name: "Nombre completo",
      namePlaceholder: "Juan Pérez",
      email: "Correo electrónico",
      emailPlaceholder: "juan.perez@email.com",
      phone: "Teléfono",
      phonePlaceholder: "+34 612 345 678",
      subject: "Asunto de la reunión",
      subjectPlaceholder: "Entrevista para el puesto de...",
      book: "Reservar",
      booking: "Reservando...",
      successTitle: "¡Cita confirmada!",
      successMessage: "Recibirás un correo de confirmación en breve.",
      errorTitle: "Error",
      errorMessage: "Se produjo un error. Por favor, inténtalo de nuevo.",
      notFound: "Página de reserva no encontrada",
      notActive: "Las reservas no están habilitadas para este reclutador",
      required: "Campo requerido",
      invalidEmail: "Correo electrónico inválido",
      duration: "Duración",
      minutes: "minutos",
      today: "Hoy",
      tomorrow: "Mañana",
      loading: "Cargando...",
      meetingTypeFixed: "El tipo de reunión ha sido definido por el reclutador"
    },
    
    // Holiday settings
    holidays: {
      title: "Días festivos",
      description: "Gestiona los días en que no estás disponible",
      add: "Añadir día festivo",
      none: "Ningún día festivo definido",
      initialize: "Inicializar",
      date: "Fecha",
      name: "Nombre",
      namePlaceholder: "Nombre del día festivo",
      recurring: "Recurrente",
      recurringBadge: "Recurrente",
      global: "Para todo el equipo",
      empty: "Sin días festivos configurados",
      legendGlobal: "Día festivo global",
      legendPersonal: "Día festivo personal",
      confirmDelete: "¿Estás seguro de que quieres eliminar este día festivo?",
      confirmDeleteTitle: "Eliminar Día Festivo",
      error: {
        fetch: "Error al cargar días festivos",
        add: "Error al añadir día festivo",
        delete: "Error al eliminar día festivo",
        required: "Por favor, completa todos los campos",
        nameRequired: "El nombre del día festivo es obligatorio",
        initialize: "Error al inicializar días festivos"
      },
      success: {
        add: "Día festivo añadido con éxito",
        delete: "Día festivo eliminado con éxito",
        initialize: "{{count}} días festivos añadidos"
      },
      confirm: {
        delete: "¿Estás seguro de que quieres eliminar este día festivo?",
        deleteTitle: "Eliminar Día Festivo",
        initialize: "¿Quieres inicializar los días festivos franceses por defecto?"
      }
    },
    
    // Video conference settings
    video: {
      title: "Configuración de videoconferencia",
      description: "Configura tu herramienta de reunión para citas en línea",
      adminOnly: "Configuración de administrador",
      adminOnlyDesc: "Esta configuración se aplica a todos los usuarios del espacio de trabajo",
      adminOnlyTitle: "Acceso de administrador requerido",
      adminOnlyMessage: "Solo los administradores pueden configurar los ajustes de videoconferencia.",
      provider: "Proveedor de videoconferencia",
      apiConfig: "Configuración API",
      generalSettings: "Configuración general",
      defaultDuration: "Duración predeterminada",
      timezone: "Zona horaria",
      active: "Activar videoconferencia para citas",
      configured: "(Configurado)",
      configuredNote: "Por razones de seguridad, los valores sensibles no se muestran. Introduce nuevos valores solo si deseas modificarlos.",
      enterValue: "Introduce el valor",
      instructions: "Instrucciones de configuración",
      fields: {
        api_key: "Clave API",
        api_secret: "Secreto API",
        refresh_token: "Token de actualización",
        webhook_secret: "Secreto Webhook",
        clientId: "Client ID",
        clientSecret: "Client Secret",
        accountId: "Account ID",
        tenantId: "Tenant ID",
        botToken: "Bot Token",
        appId: "App ID"
      },
      testMeeting: "Probar creación",
      authorizeGoogle: "Autorizar Google Meet",
      googleAuthorized: "Google Meet está autorizado y listo para usar",
      meetInstructions: "Google Meet genera enlaces automáticamente. No se requiere configuración API.",
      meetInstructions1: "Accede a Google Cloud Console",
      meetInstructions2: "Crea un nuevo proyecto o selecciona uno existente",
      meetInstructions3: "Activa Google Calendar API y Google Meet API",
      meetInstructions4: "Crea credenciales OAuth 2.0",
      meetInstructions5: "Agrega URIs de redirección autorizados",
      zoomInstructions1: "Inicia sesión en tu cuenta de Zoom Marketplace",
      zoomInstructions2: "Crea una app OAuth Server-to-Server",
      zoomInstructions3: "Agrega los permisos meeting:write y meeting:read",
      zoomInstructions4: "Copia el Account ID, Client ID y Client Secret",
      teamsInstructions1: "Accede a Azure Active Directory",
      teamsInstructions2: "Registra una nueva aplicación",
      teamsInstructions3: "Configura los permisos: OnlineMeetings.ReadWrite",
      teamsInstructions4: "Crea un secreto de cliente",
      teamsInstructions5: "Anota el Tenant ID y Client ID",
      slackInstructions1: "Crea una app de Slack",
      slackInstructions2: "Agrega los permisos: calls:write, calls:read",
      slackInstructions3: "Instala la app en tu espacio de trabajo",
      slackInstructions4: "Copia el Bot User OAuth Token",
      error: {
        fetch: "Error al cargar configuración",
        save: "Error al guardar configuración",
        delete: "Error al eliminar configuración",
        noProvider: "Por favor, selecciona un proveedor",
        missingFields: "Por favor, completa todos los campos requeridos",
        googleAuth: "Error durante la autenticación de Google",
        googleCallback: "Error durante la autenticación",
        testMeeting: "Error durante la prueba"
      },
      success: {
        save: "Configuración guardada con éxito",
        delete: "Configuración eliminada",
        googleAuth: "Google Meet autenticado con éxito",
        testMeeting: "Reunión de prueba creada con éxito"
      },
      confirm: {
        deleteTitle: "Eliminar configuración",
        delete: "¿Estás seguro de que quieres eliminar esta configuración?"
      }
    },
    
    // Appointment invitation modal
    invite: {
      title: "Enviar invitación",
      subtitle: "Invitar a {{name}} a reservar una cita",
      meetingType: "Tipo de reunión",
      physical: "Presencial",
      physicalDesc: "Reunión cara a cara",
      online: "En línea",
      onlineDesc: "Videoconferencia",
      emailPreview: "Vista previa del correo",
      subject: "Asunto",
      body: "Mensaje",
      sendTo: "Enviar a",
      position: "Puesto",
      send: "Enviar invitación",
      error: {
        noUrl: "Por favor, configura tu URL de reserva en la configuración",
        noType: "Por favor, selecciona el tipo de reunión",
        noVideoAdmin: "Por favor, configura tu herramienta de reunión en Configuración > Integración de reuniones.",
        noVideoUser: "Por favor, contacta a tu administrador para habilitar la integración de herramientas de videoconferencia.",
        send: "Error al enviar invitación"
      },
      warning: {
        noVideoAdmin: "Advertencia: No hay herramienta de videoconferencia configurada. Configúrala en la configuración.",
        noVideoUser: "Advertencia: La videoconferencia no está configurada. Contacta a tu administrador."
      }
    },
    
    // Send appointment modal
    sendModal: {
      title: "Enviar invitación de cita",
      bookingActive: "Tus reservas están activadas",
      bookingInactive: "Reservas no activadas",
      bookingUrl: "URL de reserva",
      bookingNotConfigured: "URL de reserva no configurada",
      configureBookingUrl: "Debes configurar y activar tu URL de reserva en la configuración antes de enviar invitaciones",
      goToSettings: "Ir a configuración",
      activateBooking: "Activa las reservas en la configuración para permitir que los candidatos programen citas",
      meetingType: "Tipo de reunión",
      letCandidateChoose: "Dejar elegir",
      candidateWillChoose: "El candidato elegirá",
      online: "En línea",
      physical: "Presencial",
      noVideoConfig: "Ningún servicio de videoconferencia configurado",
      configureNow: "Configurar ahora",
      candidateName: "Nombre del candidato",
      candidateNamePlaceholder: "Juan Pérez",
      candidateEmail: "Email del candidato",
      candidateEmailPlaceholder: "juan.perez@email.com",
      subject: "Asunto",
      subjectPlaceholder: "Invitación para entrevista",
      message: "Mensaje personalizado",
      messagePlaceholder: "Hola, nos gustaría reunirnos contigo para discutir tu candidatura...",
      infoTitle: "Información importante:",
      info1: "Si eliges el tipo de reunión, el candidato no podrá cambiarlo",
      info2: "Si dejas que el candidato elija, podrá seleccionar entre en línea y presencial",
      info3: "Para las reuniones en línea, asegúrate de haber configurado un servicio de videoconferencia",
      send: "Enviar invitación",
      success: "Invitación enviada con éxito",
      errors: {
        missingInfo: "Por favor, completa todos los campos obligatorios",
        bookingNotConfigured: "La URL de reserva no está configurada. Configúrala en ajustes.",
        noVideoConfig: "Por favor, marca la casilla 'Proporcionaré la URL de la reunión manualmente' para continuar",
        invalidEmail: "El correo del candidato no es válido.",
        invalidMeetingType: "El tipo de reunión no es válido.",
        invalidOffer: "La oferta seleccionada no es válida.",
        invalidCv: "El CV seleccionado no es válido.",
        sendFailed: "Error al enviar la invitación"
      },
      manualUrlRequired: "Deberás proporcionar manualmente la URL de la reunión al confirmar la cita.",
      confirmManualUrl: "Proporcionaré la URL de la reunión manualmente",
      configureAuto: "Configurar generación automática",
      videoConfigured: "Videoconferencia configurada",
      autoUrlGeneration: "La URL de la reunión se generará automáticamente al confirmar."
    },
    
    // Backend error messages
    errors: {
      // General
      serverError: "Error del servidor",
      missingInfo: "Información faltante",
      invalidData: "Datos inválidos",
      notFound: "No encontrado",
      unauthorized: "No autorizado",
      rateLimited: "Demasiadas solicitudes. Por favor, inténtelo de nuevo en unos minutos.",
      
      // Booking errors
      bookingNotFound: "Página de reserva no encontrada",
      bookingNotActive: "Las reservas no están habilitadas para este reclutador",
      datesRequired: "Fechas requeridas",
      slotNotAvailable: "Este horario ya no está disponible",
      bookingCreationError: "Error al crear la cita",
      invalidToken: "Token inválido o ya utilizado",
      appointmentAlreadyCancelled: "Token inválido o cita ya cancelada",
      
      // Availability errors
      invalidTimeFormat: "Formato de hora inválido. Use HH:MM",
      endTimeBeforeStart: "La hora de fin debe ser después de la hora de inicio",
      invalidDayOfWeek: "El día de la semana debe estar entre 0 y 6",
      overlappingSlots: "Este horario se superpone con horarios existentes",
      availabilityNotFound: "Disponibilidad no encontrada",
      availabilityFetchError: "Error al obtener las disponibilidades",
      availabilityCreateError: "Error al crear la disponibilidad",
      availabilityUpdateError: "Error al actualizar la disponibilidad",
      availabilityDeleteError: "Error al eliminar la disponibilidad",
      
      // Video conference errors
      invalidProvider: "Proveedor inválido. Elija entre: zoom, meet, teams, slack",
      videoNotConfigured: "La videoconferencia no está configurada para este espacio de trabajo",
      zoomKeysNotConfigured: "Las claves API de Zoom no están configuradas",
      unsupportedProvider: "Proveedor de videoconferencia no soportado",
      meetingLinkError: "Error al generar el enlace de la reunión",
      videoSettingsFetchError: "Error al obtener la configuración",
      videoSettingsSaveError: "Error al guardar la configuración",
      videoSettingsDeleteError: "Error al eliminar la configuración",
      providerAlreadyConfigured: "Ya hay un proveedor de videoconferencia configurado. Por favor, elimine la configuración existente antes de configurar uno nuevo.",
      
      // Settings errors
      slugAlreadyTaken: "Esta URL ya está en uso",
      invalidDuration: "Duración inválida",
      invalidSlug: "URL inválida",
      settingsFetchError: "Error al cargar la configuración",
      settingsSaveError: "Error al guardar la configuración",
      
      // Holiday errors
      holidayNameRequired: "El nombre del día festivo es requerido",
      holidayNotFound: "Día festivo no encontrado",
      holidayAlreadyExists: "Ya existe un día festivo en esta fecha",
      holidayFetchError: "Error al cargar los días festivos",
      holidayCreateError: "Error al agregar el día festivo",
      holidayDeleteError: "Error al eliminar el día festivo",
      
      // Appointment errors
      appointmentNotFound: "Cita no encontrada",
      appointmentFetchError: "Error al cargar las citas",
      appointmentConfirmError: "Error al confirmar la cita",
      appointmentCancelError: "Error al cancelar la cita",
      meetingUrlRequired: "La URL de la reunión es requerida",
      adminVideoConfigRequired: "Por favor, configure su herramienta de reunión en Configuración > Integración de reuniones.",
      userVideoConfigRequired: "Por favor, contacte a su administrador para habilitar la integración de herramientas de videoconferencia.",
      
      // Send invitation errors
      noBookingUrl: "Por favor, configure su URL de reserva en la configuración",
      invitationSendError: "Error al enviar la invitación",
      candidateNotFound: "Candidato no encontrado",
      
      // Email errors
      emailSendError: "Error al enviar el correo electrónico",
      templateFetchError: "Error al cargar las plantillas",
      templateSaveError: "Error al guardar la plantilla",
      templateResetError: "Error al restablecer la plantilla"
    }
  },
  // Super Admin
  superadmin: {
    dashboard: {
      title: "Panel de Super Admin",
      subtitle: "Vista general de la plataforma CV Analyzer",
      newUsers7d: "Nuevos usuarios (7 días)",
      envConfigured: "Variables configuradas",
      modulesTitle: "Módulos de la plataforma",
      analyses: "análisis"
    },
    stats: {
      totalUsers: "Total de Usuarios",
      administrators: "Administradores",
      activeSubscriptions: "Suscripciones Activas",
      admins: "admins",
      rh: "RH"
    },
    admins: {
      title: "Gestión de Administradores",
      subtitle: "Haz clic en un administrador para ver sus usuarios RH",
      rhUsers: "usuarios RH",
      plan: "Plan"
    },
    users: {
      title: "Gestión de Usuarios",
      subtitle: "Gestiona administradores y sus colaboradores RH",
      searchPlaceholder: "Buscar por nombre o email",
      resultsCount: "Resultados",
      noResults: "No se encontraron administradores",
      rhUsersTitle: "Usuarios RH",
      noRhUsers: "No hay usuarios RH vinculados a este administrador",
      activate: "Activar",
      deactivate: "Desactivar",
      delete: "Eliminar",
      deleteBlocked: "Elimina primero los RH vinculados a este administrador",
      deleteConfirmTitle: "Eliminar usuario",
      deleteConfirmMessage: "¿Seguro que quieres eliminar a {{userName}}? Esta acción es permanente.",
      stats: {
        admins: "Admins",
        activeAdmins: "Admins activos",
        rhUsers: "Usuarios RH",
        activeRh: "RH activos"
      }
    },
    actions: {
      userManagement: "Gestión de usuarios",
      userDescription: "Gestiona admins y usuarios RH",
      variables: "Variables de entorno",
      variablesDescription: "Configura claves críticas de runtime",
      analytics: "Analíticas",
      analyticsDescription: "Estadísticas detalladas de la plataforma"
    },
    community: {
      title: "Lista de comunidad",
      subtitle: "Correos capturados desde la sección pública de lanzamiento",
      searchPlaceholder: "Buscar por correo",
      empty: "No se encontraron correos",
      stats: {
        total: "Total correos",
        newLast7Days: "Últimos 7 días"
      },
      table: {
        email: "Correo",
        language: "Idioma",
        source: "Fuente",
        createdAt: "Fecha de alta"
      },
      errors: {
        load: "Error al cargar la lista de comunidad"
      }
    },
    errors: {
      loadStats: "Error al cargar estadísticas",
      loadAdmins: "Error al cargar administradores",
      updateStatus: "Error al actualizar estado",
      deleteUser: "Error al eliminar usuario"
    },
    success: {
      statusUpdated: "Estado del usuario actualizado",
      userDeleted: "Usuario eliminado con éxito"
    },
    confirm: {
      deleteUser: "¿Estás seguro de que quieres eliminar este usuario?"
    },
    env: {
      title: "Variables de entorno",
      subtitle: "Configura claves críticas (Almacenamiento, IA, Email).",
      categories: {
        urls: "URLs",
        core: "Core",
        storage: "Almacenamiento Candio",
        email: "Email del sistema",
        ai: "IA",
        video: "Video",
        other: "Otros"
      },
      labels: {
        secret: "Secreto",
        plain: "Público"
      },
      actions: {
        add: "Agregar",
        showValue: "Mostrar valor",
        hideValue: "Ocultar valor"
      },
      search: "Buscar",
      searchPlaceholder: "Buscar clave o descripción...",
      fields: {
        key: "Clave",
        selectKey: "Seleccionar una clave",
        value: "Valor",
        category: "Categoría"
      },
      status: {
        configured: "Configurada",
        missing: "Faltante"
      },
      stats: {
        total: "Variables totales",
        configured: "Configuradas",
        missing: "Faltantes",
        secret: "Claves secretas"
      },
      empty: "No se encontraron variables para este filtro",
      table: {
        key: "Clave",
        category: "Categoría",
        status: "Estado",
        preview: "Vista previa",
        actions: "Acciones"
      },
      modal: {
        create: "Agregar variable",
        edit: "Editar variable",
        helper: "Configura una variable de entorno crítica"
      },
      errors: {
        load: "Error al cargar variables",
        loadSingle: "No se pudo cargar la variable",
        missing: "Clave y valor son obligatorios",
        save: "Error al guardar la variable",
        delete: "Error al eliminar la variable"
      },
      success: {
        saved: "Variable guardada",
        updated: "Variable actualizada",
        deleted: "Variable eliminada",
        refreshed: "Variables actualizadas"
      },
      confirmTitle: "Confirmar eliminación",
      confirmDelete: "¿Eliminar esta variable? Esta acción es irreversible.",
      groupSummary: "Público: {{public}} • Secreto: {{secret}}"
    }
  },
  // CV Preview
  cvPreview: {
    title: "Vista previa de CV",
    addedOn: "Añadido el",
    poweredBy: "Vista previa PDF • Powered by PDF.js",
    zoomOut: "Alejar",
    zoomIn: "Acercar",
    resetZoom: "Restablecer zoom",
    docxFile: "Archivo DOCX",
    docxNotSupported: "La vista previa directa de archivos DOCX aún no está disponible.",
    docxPreview: "Vista previa del contenido DOCX",
    loading: "Cargando...",
    loadingPdf: "Cargando PDF...",
    retrying: "Reintentando...",
    retry: "Reintentar",
    downloadCta: "Descargar CV",
    extractedContent: "Contenido extraído:",
    textNotExtracted: "El texto aún no se ha extraído de este archivo.",
    downloadFile: "Descargar archivo",
    oldDocFormat: "Archivo DOC (formato antiguo)",
    oldDocNotSupported: "La vista previa de archivos .DOC no es compatible. Descarga el archivo para verlo.",
    unsupportedFormat: "Formato no compatible",
    unsupportedMessage: "Este tipo de archivo no se puede previsualizar.",
    errors: {
      loadFailed: "No se pudo cargar el PDF",
      pdfCorrupted: "El archivo PDF está dañado o es inválido",
      pdfJsUnavailable: "PDF.js no está disponible",
      network: "Error de red al cargar el PDF",
      passwordProtected: "Este PDF está protegido con contraseña",
      configuration: "Error de configuración de PDF.js - por favor inténtalo de nuevo",
      fileAccess: "No se puede acceder al archivo PDF en el servidor",
      generic: "Error al cargar: {{message}}"
    }
  },

  // Candidate Modal
  candidateModal: {
    title: {
      edit: "Editar candidato",
      create: "Crear ficha de candidato"
    },
    subtitle: "Completa la ficha del candidato con un perfil claro y accionable para el flujo de RRHH.",
    sections: {
      identity: "Identidad",
      positioning: "Posicionamiento"
    },
    fields: {
      photo: "Foto",
      photoHelp: "PNG, JPG, GIF hasta 5MB",
      firstName: "Nombre",
      lastName: "Apellido",
      title: "Título / Perfil",
      specialty: "Especialidad",
      score: "Puntuación (0-100)",
      careerSummary: "Resumen profesional",
      strengths: "Fortalezas",
      weaknesses: "Áreas de mejora"
    },
    placeholders: {
      title: "Ej: Desarrollador Full Stack Senior",
      specialty: "Ej: React, Node.js, AWS",
      careerSummary: "Describe brevemente la trayectoria profesional del candidato...",
      strengths: "Enumera las principales fortalezas del candidato...",
      weaknesses: "Identifica posibles áreas de mejora..."
    },
    buttons: {
      cancel: "Cancelar",
      create: "Crear",
      update: "Actualizar",
      saving: "Guardando..."
    },
    success: {
      created: "Candidato creado con éxito",
      updated: "Candidato actualizado con éxito"
    },
    errors: {
      photoSize: "La foto no debe superar 5 MB",
      saveFailed: "Error al guardar"
    }
  },

  // AI configuration guard
  aiConfig: {
    modal: {
      title: "Se requiere configuración de IA",
      message: "Los tokens de los proveedores de IA no están configurados. Agrega tus claves API en Configuración > Desarrollador > Proveedores de IA.",
      goToSettings: "Ir a configuración",
      cancel: "Cerrar"
    },
    errors: {
      invalidToken: "Clave API de IA inválida. Verifica tus tokens en Configuración > Desarrollador > Proveedores de IA."
    }
  },

  // License
  license: {
    expired: {
      message: "Su licencia ha expirado. Renueve su suscripción para continuar usando todas las funciones.",
      rhMessage: "El plan de su administrador ha expirado. Por favor, contacte a su administrador para renovar la suscripción.",
      renew: "Renovar"
    }
  },

  // Payment
  payment: {
    success: {
      planUpdated: "¡Plan actualizado a {{planName}}!",
      processed: "¡Pago procesado con éxito!",
      subscriptionActivated: "¡Suscripción activada con éxito!"
    },
    processing: {
      finalizing: "Finalizando su suscripción...",
      finalInProgress: "Finalización en progreso... Por favor espere un momento.",
      updateInProgress: "Actualización en progreso... Por favor actualice la página en unos momentos."
    },
    error: {
      syncError: "Error de sincronización. Por favor actualice la página."
    }
  },

  // Beta Launch Modal
  betaLaunch: {
    title: "Plan Beta Disponible Pronto",
    message: "Actualmente, solo el plan demo está disponible.",
    comingSoon: "¡Los planes de pago se activarán en unos días!",
    feedback: "Sus comentarios y sugerencias son muy apreciados y nos ayudan a mejorar Candio.",
    contact: "Contáctanos"
  }
};
